
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiref920"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiref920"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("7T3K5", function(module, exports) {

$parcel$export(module.exports, "ConfluenceSoftwarePage", function () { return $0648c5060b7f5d5e$export$a9a1f3ad281c228; });

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $4LHd8 = parcelRequire("4LHd8");

var $i8kxh = parcelRequire("i8kxh");

var $3LLDq = parcelRequire("3LLDq");

var $aRHrH = parcelRequire("aRHrH");
parcelRequire("gXOiJ");
var $3IGtY = parcelRequire("3IGtY");

var $9iWJ8 = parcelRequire("9iWJ8");

var $k4Qty = parcelRequire("k4Qty");

var $aR9rM = parcelRequire("aR9rM");
const $0648c5060b7f5d5e$export$a9a1f3ad281c228 = (props)=>{
    // FYI, this is currently JA only, since we only have JA work space appId
    const isBootIntercom = (0, $4LHd8.default).checkGate("gwp-737-enable-intercom-chat-confluence");
    const [exposureSubAnchorFired, fireSubAnchorExposure] = (0, $9iWJ8.useExperimentExposure)((0, $9iWJ8.experiments).cfind4782LandingPageSubAnchorV3);
    (0, $iSvIT.useEffect)(()=>{
        if ((0, $aR9rM.isTargetedSubAnchor)(props.subAnchor) && !exposureSubAnchorFired) fireSubAnchorExposure();
    }, [
        exposureSubAnchorFired,
        fireSubAnchorExposure
    ]);
    const { setAnchorLocalStorage: setAnchorLocalStorage } = (0, $k4Qty.useAnchorLocalStorage)();
    (0, $iSvIT.useEffect)(()=>{
        const { keyword: keyword, subAnchor: subAnchor } = props;
        const anchorLocalStorage = {};
        if (!!keyword) anchorLocalStorage.keyword = keyword;
        if (!!subAnchor) anchorLocalStorage.subAnchor = subAnchor;
        if (Object.keys(anchorLocalStorage).length > 0) setAnchorLocalStorage(anchorLocalStorage);
    }, [
        props.keyword
    ]);
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $aRHrH.IntercomProvider), {
        appId: "p0ww63i2",
        triggerBoot: isBootIntercom,
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $3LLDq.CrossFlowTouchpointProvider), {
            screenName: "wacConfluenceProductTourPage",
            productKeys: [
                (0, $i8kxh.ProductKeys).CONFLUENCE
            ],
            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $3IGtY.ConfluenceSoftwarePageTemplate), {
                pricing: props.pricing,
                availableProducts: props.availableProducts,
                userProfile: props.userProfile,
                keyword: props.keyword
            })
        })
    });
};

});
parcelRegister("gXOiJ", function(module, exports) {
$parcel$export(module.exports, "ConfluenceSoftwarePageTemplate", function () { return (parcelRequire("3IGtY")).ConfluenceSoftwarePageTemplate; });

var $3IGtY = parcelRequire("3IGtY");

});
parcelRegister("3IGtY", function(module, exports) {

$parcel$export(module.exports, "ConfluenceSoftwarePageTemplate", function () { return $e0a1ec5a2bd432b5$export$6a834c6096a76a8; });

var $7Knp0 = parcelRequire("7Knp0");

var $loA2J = parcelRequire("loA2J");

var $kZ6Ew = parcelRequire("kZ6Ew");
const $e0a1ec5a2bd432b5$export$6a834c6096a76a8 = (props)=>{
    const ConfluenceSoftwarePageComponent = (0, $kZ6Ew.ConfluenceSoftwarePage);
    return /*#__PURE__*/ (0, $loA2J.jsx)(ConfluenceSoftwarePageComponent, (0, $7Knp0._)({}, props));
};

});
parcelRegister("kZ6Ew", function(module, exports) {

$parcel$export(module.exports, "ConfluenceSoftwarePage", function () { return $a520cbe10fddbffd$export$a9a1f3ad281c228; });
/* confluence-software-page.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $277zl = parcelRequire("277zl");

var $5ohHq = parcelRequire("5ohHq");

var $4XrxY = parcelRequire("4XrxY");

var $kex29 = parcelRequire("kex29");

var $jq0gD = parcelRequire("jq0gD");

var $XSkIb = parcelRequire("XSkIb");

var $kUA6j = parcelRequire("kUA6j");

var $1MbAx = parcelRequire("1MbAx");

var $ccYBS = parcelRequire("ccYBS");

var $fsHul = parcelRequire("fsHul");

var $kGZng = parcelRequire("kGZng");

var $bP0EV = parcelRequire("bP0EV");

var $662uD = parcelRequire("662uD");

var $bGVjH = parcelRequire("bGVjH");

var $12KoV = parcelRequire("12KoV");

var $dIO0r = parcelRequire("dIO0r");

var $bCSEP = parcelRequire("bCSEP");

var $3Z0sj = parcelRequire("3Z0sj");

var $k2Kr3 = parcelRequire("k2Kr3");

var $gwC97 = parcelRequire("gwC97");

var $lpMJ8 = parcelRequire("lpMJ8");

var $kYHPO = parcelRequire("kYHPO");
const $a520cbe10fddbffd$var$relativeParent = null;
const $a520cbe10fddbffd$var$relativeChildren = null;
const $a520cbe10fddbffd$var$backgroundShape = null;
const $a520cbe10fddbffd$var$ConfluenceSoftwarePageComponent = ({ availableProducts: availableProducts, userProfile: userProfile })=>{
    const { userProfileName: userProfileName, recentSites: recentSites, shouldShowLogMeIn: shouldShowLogMeIn } = (0, $277zl.useLogMeIn)({
        availableProducts: availableProducts,
        userProfile: userProfile,
        siteType: (0, $277zl.AtlSiteType).CONFLUENCE
    });
    return /*#__PURE__*/ (0, $loA2J.jsxs)((0, $iSvIT.Fragment), {
        children: [
            /*#__PURE__*/ (0, $loA2J.jsxs)((0, $jq0gD.default), {
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $XSkIb.ConfluenceAboveNavButterbar), {}),
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $kGZng.default), {})
                ]
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.TypographyStyles), {
                children: /*#__PURE__*/ (0, $loA2J.jsx)("main", {
                    id: "content",
                    children: /*#__PURE__*/ (0, $loA2J.jsxs)((0, $ccYBS.ParentScrollTracking), {
                        scrollTrackingEnabled: true,
                        pageId: "confluence-software-page-cfind-1234",
                        children: [
                            /*#__PURE__*/ (0, $loA2J.jsx)((0, $kUA6j.ConfluencePageBanner), {}),
                            shouldShowLogMeIn ? /*#__PURE__*/ (0, $loA2J.jsx)((0, $bCSEP.default), {
                                confluenceSites: recentSites,
                                userProfileName: userProfileName
                            }) : /*#__PURE__*/ (0, $loA2J.jsx)((0, $12KoV.default), {
                                userProfile: userProfile
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)((0, $bP0EV.default), {}),
                            /*#__PURE__*/ (0, $loA2J.jsx)((0, $k2Kr3.default), {}),
                            /*#__PURE__*/ (0, $loA2J.jsx)((0, $3Z0sj.default), {}),
                            /*#__PURE__*/ (0, $loA2J.jsx)((0, $gwC97.default), {}),
                            /*#__PURE__*/ (0, $loA2J.jsx)((0, $kYHPO.default), {}),
                            /*#__PURE__*/ (0, $loA2J.jsx)((0, $lpMJ8.default), {}),
                            /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                                className: (0, $esG4f.default)([
                                    "_kqswh2mm _1e0c1txw _1bah1h6o _1reo15vq _18m915vq"
                                ]),
                                children: [
                                    /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                        className: (0, $esG4f.default)([
                                            "_mkrz1cp6 _bfhk1rga _kqswstnw _152tidpf _1reo15vq _18m915vq _1bsb1wqz _4t3i16il _197pglyw _1knecv93"
                                        ]),
                                        style: {
                                            "--_1nu1zxz": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light100"))
                                        }
                                    }),
                                    /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                                        className: (0, $esG4f.default)([
                                            "_1e0c1txw _2lx21bp4 _kqswh2mm _1pfh1ymo _zulpmxpn _2osn1sxy _1iyeviql"
                                        ]),
                                        children: [
                                            /*#__PURE__*/ (0, $loA2J.jsx)((0, $dIO0r.default), {}),
                                            /*#__PURE__*/ (0, $loA2J.jsx)((0, $fsHul.default), {})
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)((0, $bGVjH.default), {}),
                            /*#__PURE__*/ (0, $loA2J.jsx)((0, $662uD.default), {})
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $kex29.GlobalFooter), {})
        ]
    });
};
const $a520cbe10fddbffd$export$a9a1f3ad281c228 = (0, $1MbAx.withFeatureExposed)("cfind-1234-product-tour-refresh-q3fy24", "Test", $a520cbe10fddbffd$var$ConfluenceSoftwarePageComponent);

});
parcelRegister("XSkIb", function(module, exports) {

$parcel$export(module.exports, "ConfluenceAboveNavButterbar", function () { return $ad12215f04a81ca7$export$86417e4293705c14; });

var $7Knp0 = parcelRequire("7Knp0");

var $loA2J = parcelRequire("loA2J");

var $dFnC9 = parcelRequire("dFnC9");
var $f6qj2 = parcelRequire("f6qj2");

var $3FBn4 = parcelRequire("3FBn4");

var $47768 = parcelRequire("47768");

var $9iWJ8 = parcelRequire("9iWJ8");
const $ad12215f04a81ca7$export$86417e4293705c14 = ()=>{
    const intl = (0, $f6qj2.default)();
    const gwp5090BannerExperiment = (0, $9iWJ8.useExperiment)((0, $9iWJ8.experiments).gwp5090ExperimentBannerConfluence);
    const gwp5090IsButterBar = gwp5090BannerExperiment != undefined && gwp5090BannerExperiment.type === "enrolled" && gwp5090BannerExperiment.value === "butterbar";
    const gwp5090Team25Config = {
        identifier: "GWP5090.confluence-product-tour.butterbar",
        text: /*#__PURE__*/ (0, $loA2J.jsx)((0, $loA2J.Fragment), {
            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                id: "team25-banners-and-butterbars.confluence.text",
                defaultMessage: "<strong>April 8-10 \u2022 Anaheim, California</strong>Hear from the world\u2019s leading product experts on how to boost team performance at Team \u201925!",
                values: (0, $3FBn4.DEFAULT_VALUES)
            })
        }),
        mobileText: /*#__PURE__*/ (0, $loA2J.jsx)((0, $loA2J.Fragment), {
            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                id: "team25-banners-and-butterbars.confluence.mobile-text",
                defaultMessage: "<strong>April 8-10 \u2022 Anaheim, California</strong>Hear from leading product experts!",
                values: (0, $3FBn4.DEFAULT_VALUES)
            })
        }),
        productKey: "home",
        backgroundPreset: "gwp-5090-banners",
        imageProps: {
            src: "https://dam-cdn.atl.orangelogic.com/AssetLink/4360jv8l7u81b0w6nn37fu86a2131624.webp",
            alt: "Team25",
            //Event name is not localized
            width: 200
        },
        linkText: intl.formatMessage({
            id: "team25-banners-and-butterbars.confluence.cta",
            defaultMessage: "Get your pass"
        }),
        linkUrl: "https://events.atlassian.com/team?utm_medium=event-web-referral&utm_source=confluence_product-tour&event_context=701QB00000Lg6oBYAR&utm_campaign=K:event|H:any|N:Team_25|P:agnostic|O:event-marketing|F:pre-event|C:event-home&utm_content=butterbar-banner_WEBTEAM-17396&event_id=216653",
        dataEventProps: {
            "data-product-key": "home",
            "data-event-component": "linkButton",
            "data-event-container": "announcementBanner",
            "data-event": "clicked",
            "data-label": intl.formatMessage({
                id: "team25-banners-and-butterbars.confluence.cta",
                defaultMessage: "Get your pass"
            }),
            "data-label-english": "Get your pass"
        }
    };
    return gwp5090IsButterBar ? /*#__PURE__*/ (0, $loA2J.jsx)((0, $47768.EnhancedBannerAlert), (0, $7Knp0._)({}, gwp5090Team25Config)) : null;
};

});

parcelRegister("kUA6j", function(module, exports) {

$parcel$export(module.exports, "ConfluencePageBanner", function () { return $c351a17a77c15960$export$88cfc9a6a95640d1; });

var $7Knp0 = parcelRequire("7Knp0");

var $loA2J = parcelRequire("loA2J");

var $f6qj2 = parcelRequire("f6qj2");

var $4LHd8 = parcelRequire("4LHd8");

var $fovuc = parcelRequire("fovuc");

var $3FBn4 = parcelRequire("3FBn4");

var $9iWJ8 = parcelRequire("9iWJ8");
const $c351a17a77c15960$export$88cfc9a6a95640d1 = ()=>{
    const intl = (0, $f6qj2.default)();
    const showAiBanner = (0, $4LHd8.default).checkGate("wac-uip-butter-bar-confluence-gate");
    const gwp5090BannerExperiment = (0, $9iWJ8.useExperiment)((0, $9iWJ8.experiments).gwp5090ExperimentBannerConfluence);
    const gwp5090IsButterBar = gwp5090BannerExperiment != undefined && gwp5090BannerExperiment.type === "enrolled" && gwp5090BannerExperiment.value === "butterbar";
    const aiBannerMessages = {
        identifier: "ConfluenceSoftwarePageTemplate.atlassian-intelligence_exp",
        text: intl.formatMessage({
            id: "ConfluenceSoftwarePageTemplate.banner-alert.atlassian-intelligence_exp",
            defaultMessage: "Transform teamwork with Atlassian Intelligence - now available."
        }),
        linkText: intl.formatMessage({
            id: "ConfluenceSoftwarePageTemplate.link-text",
            defaultMessage: "Learn more"
        }),
        linkUrl: (0, $3FBn4.useLocalizedHref)("/software/artificial-intelligence"),
        dataEventProps: {
            "data-product-key": "confluence",
            "data-event-component": "linkButton",
            "data-event-container": "announcementBanner",
            "data-event": "clicked",
            "data-label": "Learn more",
            "data-label-english": "Learn more",
            "data-track-event": "confluencePageBanner.announcementBanner.learnMore"
        }
    };
    return !gwp5090IsButterBar && showAiBanner ? /*#__PURE__*/ (0, $loA2J.jsx)((0, $fovuc.default), (0, $7Knp0._)({}, aiBannerMessages)) : null;
};

});

parcelRegister("fsHul", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cff6238659d3f495$export$2e2bcd8739ae039; });
/* ai-section.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $dFnC9 = parcelRequire("dFnC9");
var $f6qj2 = parcelRequire("f6qj2");

var $dyZbY = parcelRequire("dyZbY");

var $91nJf = parcelRequire("91nJf");

var $f0Hih = parcelRequire("f0Hih");
parcelRequire("bBpPL");
var $gv8b3 = parcelRequire("gv8b3");
parcelRequire("hnZ2m");
var $aiwTz = parcelRequire("aiwTz");

var $ccYBS = parcelRequire("ccYBS");
const $cff6238659d3f495$var$AISection = ()=>{
    const intl = (0, $f6qj2.default)();
    const [isModalOpen, setIsModalOpen] = (0, $iSvIT.useState)(false);
    const { ref: ref } = (0, $ccYBS.useScrollTracking)("AISection", {
        observerOptions: {
            threshold: 0.25
        }
    });
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $dyZbY.default), {
        name: "confluence-pt-cfind-1234-aiSection",
        children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
            ref: ref,
            className: (0, $esG4f.default)([
                "_12l0y52h _46zeidpf _168b1l27 _ztwyidpf _1y1e1l27 _1brwstnw _1bzd9by0 _15w9stnw _j19k12am _voa41wug _19xgidpf _thu2fatv _1kplidpf _1p4vfatv"
            ]),
            children: [
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $gv8b3.Ai), {
                    theme: "light",
                    title: intl.formatMessage({
                        id: "ConfluenceSoftwarePage.v4.AISection.title",
                        defaultMessage: "Leave the busywork to AI"
                    }),
                    videoLink: "https://dam-cdn.atl.orangelogic.com/AssetLink/50m38s3ne34430160w3lr4jcg67ykb0t.mp4",
                    includeFooter: false,
                    button: /*#__PURE__*/ (0, $loA2J.jsx)((0, $f0Hih.default), {
                        intentType: "button",
                        containerId: "aiSection",
                        productKey: "confluence",
                        edition: "free",
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $91nJf.Adg4Button), {
                            variant: "secondary",
                            color: "black",
                            size: "large",
                            dataEventProps: {
                                "data-product-key": "confluence",
                                "data-event": "clicked",
                                "data-event-component": "linkButton",
                                "data-event-container": "aiSection",
                                "data-label": "explore-atlassian-intelligence",
                                "data-label-english": "Explore Atlassian Intelligence",
                                "data-track-event": "confluence-pt.ai.explore-atlassian-intelligence"
                            },
                            onClick: ()=>setIsModalOpen(true),
                            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                                id: "ConfluenceSoftwarePage.v4.AISection.button",
                                defaultMessage: "Explore Atlassian Intelligence"
                            })
                        })
                    }),
                    buttonPosition: "bottom",
                    videoContainerClassName: "video-container",
                    showBurst: true,
                    burstClassName1: "burst-container1",
                    burstClassName2: "burst-container2",
                    videoClassName: "video"
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $aiwTz.YoutubeModal), {
                    isOpen: isModalOpen,
                    closeModal: ()=>setIsModalOpen(false),
                    src: "https://www.youtube.com/embed/ivIV1a8W0e4?si=iNOFdEMuDzTKN4X_?autoplay=1&rel=0&origin=https%3A%2F%2Fwww.atlassian.com&widget_referrer=https%3A%2F%2Fwww.atlassian.com&enablejsapi=1&widgetid=1&autoplay=1",
                    title: intl.formatMessage({
                        id: "ConfluenceSoftwarePage.v4.AISection.ModalYouTubeIframeTitle",
                        defaultMessage: "Empower Teams with Atlassian Intelligence in Confluence | Atlassian"
                    }),
                    closeIconLabel: intl.formatMessage({
                        id: "ConfluenceSoftwarePage.v4.AISection.CloseModalButtonMobileLabel",
                        defaultMessage: "Close modal"
                    })
                })
            ]
        })
    });
};
$cff6238659d3f495$var$AISection.displayName = "AISection";
var $cff6238659d3f495$export$2e2bcd8739ae039 = $cff6238659d3f495$var$AISection;

});
parcelRegister("bBpPL", function(module, exports) {
$parcel$export(module.exports, "Ai", function () { return (parcelRequire("gv8b3")).Ai; });
parcelRequire("gv8b3");

});
parcelRegister("gv8b3", function(module, exports) {

$parcel$export(module.exports, "Ai", function () { return $80cdc684ec014218$export$7ae07b56aa46260e; });
/* ai.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $f6qj2 = parcelRequire("f6qj2");

var $cRwVc = parcelRequire("cRwVc");
parcelRequire("i12Ys");
var $fwNUF = parcelRequire("fwNUF");
var $696L5 = parcelRequire("696L5");
const $80cdc684ec014218$var$aiParentStyles = null;
const $80cdc684ec014218$var$videoStyles = null;
const $80cdc684ec014218$var$imageStyles = null;
const $80cdc684ec014218$var$footerStyles = null;
const $80cdc684ec014218$export$7ae07b56aa46260e = ({ theme: theme, title: title, buttonPosition: buttonPosition, button: button, videoLink: videoLink, includeFooter: includeFooter, showBurst: showBurst, videoContainerClassName: videoContainerClassName, videoClassName: videoClassName, burstClassName1: burstClassName1, burstClassName2: burstClassName2 })=>{
    const intl = (0, $f6qj2.default)();
    const aiSectionStyles = null;
    const buttonSectionStyles = null;
    const titleStyles = null;
    const burstStyles1 = null;
    const burstStyles2 = null;
    const videoContainerStyles = null;
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        className: (0, $esG4f.default)([
            "_1bsb1osq"
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                className: (0, $esG4f.default)([
                    "_1e0c1txw _2lx21bp4 _4cvr1h6o _bfhk132c _syazu67f _4t3i1wug _1reo15vq _18m915vq _ca0q1f4h _u5f39by0 _n3tdidpf _19bv9by0 _1o9zidpf _1bsb1osq _kqswh2mm _9o8yglyw _tl281ylp _axwiidpf _1hwcidpf _sp8tidpf"
                ]),
                style: {
                    "--_ikl1hm": (0, $43MIc.default)(theme === "light" ? "#CFE1FD" : "#1868DB")
                },
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                        className: (0, $esG4f.default)([
                            "_kqswstnw _4t3i1uc6 _1bsb53f4 _1e029by0 _liwcglyw",
                            burstClassName1
                        ]),
                        children: showBurst && /*#__PURE__*/ (0, $loA2J.jsx)((0, $fwNUF.Burst), {})
                    }),
                    theme === "light" ? /*#__PURE__*/ (0, $loA2J.jsx)((0, $696L5.IntelligenceLight), {}) : /*#__PURE__*/ (0, $loA2J.jsx)((0, $696L5.IntelligenceDark), {}),
                    /*#__PURE__*/ (0, $loA2J.jsx)("h2", {
                        className: (0, $esG4f.default)([
                            "_syazeqrp _y3gn1h6o _1iqs1cme _ect41pz4 _1wybckbl _zg8l4jg8 _k48p1fw0 _vwz4ckbl _85i5zwfg _flz0zwfg _1lzozwfg _1cqs1tcg"
                        ]),
                        style: {
                            "--_24lek7": (0, $43MIc.default)(theme === "light" ? "#101214" : "#FFF"),
                            "--_1h6bnby": (0, $43MIc.default)((0, $cRwVc.default)("font.charlie.display"))
                        },
                        children: title
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                        className: (0, $esG4f.default)([
                            "_1e0c1txw _2lx21bp4 _4cvr1h6o _19pk1crf _9o8yglyw",
                            buttonPosition !== "bottom" ? "" : "hide"
                        ]),
                        children: button
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                        className: (0, $esG4f.default)([
                            "_kqswstnw _4t3i7ynd _1bsb8ved _u7cogktf _rjxp9by0 _liwcglyw",
                            burstClassName2
                        ]),
                        children: showBurst && /*#__PURE__*/ (0, $loA2J.jsx)((0, $fwNUF.Burst), {})
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                        className: (0, $esG4f.default)([
                            "_4t3i1wug _liwcglyw",
                            videoContainerClassName
                        ]),
                        children: /*#__PURE__*/ (0, $loA2J.jsxs)("video", {
                            playsInline: true,
                            muted: true,
                            preload: "auto",
                            autoPlay: true,
                            loop: true,
                            className: (0, $esG4f.default)([
                                "_p12f1uof _4t3i1wug _ca0q7vkz _u5f37vkz _n3td7vkz _19bv7vkz _liwcglyw",
                                videoClassName
                            ]),
                            children: [
                                intl.formatMessage({
                                    id: "ConfluenceSoftwarePage.v4.AISection.imgAlt",
                                    defaultMessage: "demo of AI integration"
                                }),
                                /*#__PURE__*/ (0, $loA2J.jsx)("source", {
                                    src: videoLink,
                                    type: `video/webm`
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("img", {
                        src: "https://wac-cdn.atlassian.com/misc-assets/webp-images/ai-img.webp",
                        loading: "lazy",
                        alt: intl.formatMessage({
                            id: "ConfluenceSoftwarePage.v4.AISection.imgAlt",
                            defaultMessage: "demo of AI integration"
                        }),
                        className: (0, $esG4f.default)([
                            "_1bsb1osq _4t3i1wug _ca0q7vkz _u5f310yn _n3tdidpf _19bv10yn _je3oglyw"
                        ])
                    })
                ]
            }),
            includeFooter && /*#__PURE__*/ (0, $loA2J.jsx)("img", {
                src: "https://wac-cdn.atlassian.com/misc-assets/webp-images/blue-angle.webp",
                alt: "",
                className: (0, $esG4f.default)([
                    "_1bsb1osq _1pby1mrw _1pfh1n1a"
                ])
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_1e0c1txw _2lx21bp4 _4cvr1h6o _19pk1crf _9o8yglyw",
                    buttonPosition === "bottom" ? "" : "hide"
                ]),
                children: button
            })
        ]
    });
};

});
parcelRegister("i12Ys", function(module, exports) {
$parcel$export(module.exports, "IntelligenceDark", function () { return (parcelRequire("696L5")).IntelligenceDark; });
$parcel$export(module.exports, "IntelligenceLight", function () { return (parcelRequire("696L5")).IntelligenceLight; });
$parcel$export(module.exports, "Burst", function () { return (parcelRequire("fwNUF")).Burst; });
parcelRequire("696L5");
parcelRequire("fwNUF");

});
parcelRegister("696L5", function(module, exports) {

$parcel$export(module.exports, "IntelligenceDark", function () { return $75362e3825168d99$export$6c136ee6aa49536d; });
$parcel$export(module.exports, "IntelligenceLight", function () { return $75362e3825168d99$export$28c56d9c47eae24c; });

var $loA2J = parcelRequire("loA2J");
const $75362e3825168d99$export$6c136ee6aa49536d = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        children: /*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
            width: "48",
            height: "48",
            viewBox: "0 0 48 48",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                /*#__PURE__*/ (0, $loA2J.jsxs)("g", {
                    id: "Group 626186",
                    children: [
                        /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                            id: "Vector (Stroke)",
                            fillRule: "evenodd",
                            clipRule: "evenodd",
                            d: "M37.3027 23.8756C37.3027 22.4546 38.4547 21.3027 39.8757 21.3027H44.5842C46.0052 21.3027 47.1572 22.4546 47.1572 23.8756C47.1572 25.2967 46.0052 26.4486 44.5842 26.4486H39.8757C38.4547 26.4486 37.3027 25.2967 37.3027 23.8756Z",
                            fill: "url(#paint0_linear_2487_5195)"
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                            id: "Vector (Stroke)_2",
                            fillRule: "evenodd",
                            clipRule: "evenodd",
                            d: "M24.0007 0.718933C25.4217 0.718933 26.5737 1.87089 26.5737 3.2919V8.00043C26.5737 9.42144 25.4217 10.5734 24.0007 10.5734C22.5797 10.5734 21.4277 9.42144 21.4277 8.00043V3.2919C21.4277 1.87089 22.5797 0.718933 24.0007 0.718933Z",
                            fill: "url(#paint1_linear_2487_5195)"
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                            id: "Vector (Stroke)_3",
                            fillRule: "evenodd",
                            clipRule: "evenodd",
                            d: "M0.84375 23.8756C0.84375 22.4546 1.99571 21.3027 3.41672 21.3027H8.12525C9.54626 21.3027 10.6982 22.4546 10.6982 23.8756C10.6982 25.2967 9.54626 26.4486 8.12525 26.4486H3.41672C1.99571 26.4486 0.84375 25.2967 0.84375 23.8756Z",
                            fill: "url(#paint2_linear_2487_5195)"
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                            id: "Vector (Stroke)_4",
                            fillRule: "evenodd",
                            clipRule: "evenodd",
                            d: "M24.0007 37.1779C25.4217 37.1779 26.5737 38.3298 26.5737 39.7508V44.4594C26.5737 45.8804 25.4217 47.0323 24.0007 47.0323C22.5797 47.0323 21.4277 45.8804 21.4277 44.4594V39.7508C21.4277 38.3298 22.5797 37.1779 24.0007 37.1779Z",
                            fill: "url(#paint3_linear_2487_5195)"
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                            id: "Vector (Stroke)_5",
                            fillRule: "evenodd",
                            clipRule: "evenodd",
                            d: "M29.9001 29.7752C30.9049 28.7703 32.534 28.7703 33.5388 29.7752L43.8307 40.067C44.8355 41.0718 44.8355 42.7009 43.8307 43.7058C42.8259 44.7106 41.1968 44.7106 40.192 43.7058L29.9001 33.4139C28.8953 32.4091 28.8953 30.78 29.9001 29.7752Z",
                            fill: "white"
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                            id: "Vector (Stroke)_6",
                            fillRule: "evenodd",
                            clipRule: "evenodd",
                            d: "M43.8307 4.04548C44.8355 5.05028 44.8355 6.6794 43.8307 7.6842L33.5388 17.9761C32.534 18.9809 30.9049 18.9809 29.9001 17.9761C28.8953 16.9713 28.8953 15.3422 29.9001 14.3373L40.192 4.04548C41.1968 3.04067 42.8259 3.04067 43.8307 4.04548Z",
                            fill: "white"
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                            id: "Vector (Stroke)_7",
                            fillRule: "evenodd",
                            clipRule: "evenodd",
                            d: "M4.16962 4.04548C5.17443 3.04067 6.80354 3.04067 7.80835 4.04548L18.1002 14.3373C19.105 15.3422 19.105 16.9713 18.1002 17.9761C17.0954 18.9809 15.4663 18.9809 14.4615 17.9761L4.16962 7.6842C3.16481 6.6794 3.16481 5.05028 4.16962 4.04548Z",
                            fill: "white"
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                            id: "Vector (Stroke)_8",
                            fillRule: "evenodd",
                            clipRule: "evenodd",
                            d: "M18.1002 29.7752C19.105 30.78 19.105 32.4091 18.1002 33.4139L7.80835 43.7058C6.80354 44.7106 5.17443 44.7106 4.16962 43.7058C3.16481 42.7009 3.16481 41.0718 4.16962 40.067L14.4615 29.7752C15.4663 28.7703 17.0954 28.7703 18.1002 29.7752Z",
                            fill: "white"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $loA2J.jsxs)("defs", {
                    children: [
                        /*#__PURE__*/ (0, $loA2J.jsxs)("linearGradient", {
                            id: "paint0_linear_2487_5195",
                            x1: "47.1571",
                            y1: "23.8756",
                            x2: "38.1517",
                            y2: "23.8756",
                            gradientUnits: "userSpaceOnUse",
                            children: [
                                /*#__PURE__*/ (0, $loA2J.jsx)("stop", {
                                    offset: "0.270833",
                                    stopColor: "#9BC6FF"
                                }),
                                /*#__PURE__*/ (0, $loA2J.jsx)("stop", {
                                    offset: "1",
                                    stopColor: "white"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsxs)("linearGradient", {
                            id: "paint1_linear_2487_5195",
                            x1: "25.2872",
                            y1: "0.718933",
                            x2: "25.2872",
                            y2: "9.72432",
                            gradientUnits: "userSpaceOnUse",
                            children: [
                                /*#__PURE__*/ (0, $loA2J.jsx)("stop", {
                                    offset: "0.1875",
                                    stopColor: "#9BC6FF"
                                }),
                                /*#__PURE__*/ (0, $loA2J.jsx)("stop", {
                                    offset: "1",
                                    stopColor: "white"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsxs)("linearGradient", {
                            id: "paint2_linear_2487_5195",
                            x1: "10.6981",
                            y1: "23.8756",
                            x2: "1.69272",
                            y2: "23.8756",
                            gradientUnits: "userSpaceOnUse",
                            children: [
                                /*#__PURE__*/ (0, $loA2J.jsx)("stop", {
                                    stopColor: "white"
                                }),
                                /*#__PURE__*/ (0, $loA2J.jsx)("stop", {
                                    offset: "0.791667",
                                    stopColor: "#2684FF"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsxs)("linearGradient", {
                            id: "paint3_linear_2487_5195",
                            x1: "25.2872",
                            y1: "36.7404",
                            x2: "25.2872",
                            y2: "47.0323",
                            gradientUnits: "userSpaceOnUse",
                            children: [
                                /*#__PURE__*/ (0, $loA2J.jsx)("stop", {
                                    stopColor: "white"
                                }),
                                /*#__PURE__*/ (0, $loA2J.jsx)("stop", {
                                    offset: "0.802083",
                                    stopColor: "#A6CCFE"
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
const $75362e3825168d99$export$28c56d9c47eae24c = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        children: /*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
            width: "60",
            height: "60",
            viewBox: "0 0 60 60",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                    d: "M50.5501 27.4199H41.6001V32.4199H50.5501V27.4199Z",
                    fill: "url(#paint0_linear_4426_97000)"
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                    d: "M32.4253 9.29492H27.4253V18.2449H32.4253V9.29492Z",
                    fill: "url(#paint1_linear_4426_97000)"
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                    d: "M18.2503 27.4199H9.30029V32.4199H18.2503V27.4199Z",
                    fill: "url(#paint2_linear_4426_97000)"
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                    d: "M32.4253 41.595H27.4253V50.545H32.4253V41.595Z",
                    fill: "url(#paint3_linear_4426_97000)"
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                    d: "M37.8796 34.2856L34.291 37.8741L47.5051 51.0882L51.0936 47.4996L37.8796 34.2856Z",
                    fill: "#2684FF"
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                    d: "M47.5052 8.74824L34.2935 21.9646L37.8827 25.5525L51.0944 12.3362L47.5052 8.74824Z",
                    fill: "#2684FF"
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                    d: "M12.3395 8.7481L8.75098 12.3367L21.965 25.5507L25.5536 21.9622L12.3395 8.7481Z",
                    fill: "#2684FF"
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                    d: "M21.9618 34.2762L8.75 47.4926L12.3392 51.0805L25.5509 37.8641L21.9618 34.2762Z",
                    fill: "#2684FF"
                }),
                /*#__PURE__*/ (0, $loA2J.jsxs)("defs", {
                    children: [
                        /*#__PURE__*/ (0, $loA2J.jsxs)("linearGradient", {
                            id: "paint0_linear_4426_97000",
                            x1: "41.6001",
                            y1: "29.9199",
                            x2: "50.5501",
                            y2: "29.9199",
                            gradientUnits: "userSpaceOnUse",
                            children: [
                                /*#__PURE__*/ (0, $loA2J.jsx)("stop", {
                                    stopColor: "#0052CC"
                                }),
                                /*#__PURE__*/ (0, $loA2J.jsx)("stop", {
                                    offset: "0.8",
                                    stopColor: "#2684FF"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsxs)("linearGradient", {
                            id: "paint1_linear_4426_97000",
                            x1: "29.9253",
                            y1: "18.2449",
                            x2: "29.9253",
                            y2: "9.29492",
                            gradientUnits: "userSpaceOnUse",
                            children: [
                                /*#__PURE__*/ (0, $loA2J.jsx)("stop", {
                                    stopColor: "#0052CC"
                                }),
                                /*#__PURE__*/ (0, $loA2J.jsx)("stop", {
                                    offset: "0.8",
                                    stopColor: "#2684FF"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsxs)("linearGradient", {
                            id: "paint2_linear_4426_97000",
                            x1: "18.2503",
                            y1: "-0.0800891",
                            x2: "9.30029",
                            y2: "-0.0800891",
                            gradientUnits: "userSpaceOnUse",
                            children: [
                                /*#__PURE__*/ (0, $loA2J.jsx)("stop", {
                                    stopColor: "#0052CC"
                                }),
                                /*#__PURE__*/ (0, $loA2J.jsx)("stop", {
                                    offset: "0.8",
                                    stopColor: "#2684FF"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsxs)("linearGradient", {
                            id: "paint3_linear_4426_97000",
                            x1: "29.9253",
                            y1: "41.595",
                            x2: "29.9253",
                            y2: "50.545",
                            gradientUnits: "userSpaceOnUse",
                            children: [
                                /*#__PURE__*/ (0, $loA2J.jsx)("stop", {
                                    stopColor: "#0052CC"
                                }),
                                /*#__PURE__*/ (0, $loA2J.jsx)("stop", {
                                    offset: "0.8",
                                    stopColor: "#2684FF"
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};

});

parcelRegister("fwNUF", function(module, exports) {

$parcel$export(module.exports, "Burst", function () { return $67713cc528b5d64b$export$a3f4e2574d5726c7; });

var $loA2J = parcelRequire("loA2J");
const $67713cc528b5d64b$export$a3f4e2574d5726c7 = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
        viewBox: "0 0 86 85",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M40.7007 14.1674C34.894 6.10495 35.5846 12.4188 38.9551 18.1907C39.4398 15.5504 40.3978 19.8405 39.0651 18.4315C39.0463 19.1506 39.7286 22.1508 40.4308 20.9456C39.8016 21.4048 42.4581 30.0808 43.3518 24.7504C43.2753 24.6369 42.3825 25.0337 42.572 24.7366C43.69 22.5286 40.8513 17.8368 40.6978 14.1628L40.7007 14.1674Z",
                fill: "#111213"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M24.1165 33.3455C24.3704 34.0377 29.1781 37.8998 29.1178 35.3451C28.2937 34.5933 28.8737 34.0231 27.8473 34.6824C26.7515 28.5866 2.84954 20.7621 21.0405 31.5593C20.3668 29.885 21.5849 30.7022 21.9766 31.5345C20.0488 31.4834 24.2398 34.3884 23.8836 32.8848C24.2851 32.952 24.5516 33.3213 24.1165 33.3455Z",
                fill: "#111213"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M15.7083 51.6375C16.3508 51.9805 19.0481 50.6754 19.9635 50.0653C18.1731 49.685 19.6559 49.1297 20.5037 49.3266C19.6722 50.7596 22.5761 49.4556 23.151 48.8563C22.762 48.955 22.6178 48.4717 23.2188 48.3C23.9493 50.3058 31.4246 44.9641 26.5584 46.0775C25.0032 45.9635 19.65 47.7249 15.9357 48.32C15.2425 49.7063 13.9577 50.3323 12.381 50.6625C10.0879 53.4867 15.1171 53.1473 15.7008 51.6357L15.7083 51.6375Z",
                fill: "#111213"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M35.4623 56.5432C35.0962 56.2418 34.8744 57.0798 34.2236 57.1085C34.1841 57.2423 35.0696 57.6668 34.7174 57.7106C32.2276 59.1126 28.1044 64.5844 27.5687 68.8705C25.031 75.2029 31.6172 68.442 32.037 64.697C30.4251 65.5635 31.2001 64.1846 31.9792 63.7808C32.2658 65.4111 33.6465 62.5457 33.6996 61.7154C33.4636 62.0412 33.0481 61.7639 33.397 61.2462C34.0038 62.5309 37.7314 55.8562 35.4623 56.5432Z",
                fill: "#111213"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M47.5445 61.1109C47.7465 60.4073 46.1495 54.4473 44.6895 56.5385C44.8557 57.5678 44.2278 57.7689 45.3235 57.8257C44.3119 61.518 47.5357 67.6249 49.5384 71.9517C54.4828 75.7229 48.9857 62.4978 48.7485 65.2683C46.8849 64.155 50.374 63.7888 47.5491 61.108L47.5445 61.1109Z",
                fill: "#111213"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M68.081 60.87C67.506 60.7298 61.702 54.6915 62.4175 57.1311C60.2478 57.0943 63.0913 55.0365 59.2985 54.1301C59.1214 53.4163 54.7623 49.0521 54.539 51.5953C55.1987 52.4036 54.7538 52.8906 55.7259 52.3933C54.6288 53.6044 56.6163 53.3357 56.7169 53.4987C56.1274 54.7824 58.4929 54.5953 57.5662 55.0517C58.5404 57.473 68.5615 65.6671 68.0735 60.8682L68.081 60.87Z",
                fill: "#111213"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M74.1525 41.2299C71.1084 40.0993 67.3911 41.0436 65.8157 41.0322C67.1942 40.1104 64.0113 40.0045 63.2287 40.2882C63.622 40.3735 63.5412 40.8672 62.9225 40.7604C63.8553 39.6892 56.2426 38.9673 57.7848 40.7679C57.6537 41.2218 58.5161 41.0882 58.807 41.6739C58.9428 41.6544 58.9752 40.6761 59.162 40.9788C58.9268 42.5968 60.4305 41.2633 60.6023 41.3438C60.8304 42.7336 62.6879 41.2653 62.174 42.1614C64.1349 43.7549 77.7773 44.5296 74.1583 41.2392L74.1525 41.2299Z",
                fill: "#111213"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M64.2396 18.8011C61.3001 20.1721 59.3546 23.4762 58.2337 24.5863C58.5467 22.9589 56.2378 25.1432 55.8882 25.8992C56.2222 25.6802 56.5164 26.0838 56.0088 26.4486C55.9014 25.0357 50.0371 29.936 52.4026 30.1027C52.6359 30.5118 53.14 29.8083 53.7629 30.0155C53.8458 29.9 53.1705 29.1913 53.5169 29.2734C54.5039 30.5806 54.6084 28.5738 54.7885 28.5012C55.9381 29.3221 56.1975 26.9624 56.474 27.9622C59.1498 27.455 68.9328 18.9586 64.2414 18.7935L64.2396 18.8011Z",
                fill: "#111213"
            })
        ]
    });
};

});




parcelRegister("hnZ2m", function(module, exports) {

$parcel$export(module.exports, "YoutubeModal", function () { return (parcelRequire("aiwTz")).YoutubeModal; });

var $aiwTz = parcelRequire("aiwTz");

var $frRnC = parcelRequire("frRnC");

var $dABBq = parcelRequire("dABBq");

});
parcelRegister("aiwTz", function(module, exports) {

$parcel$export(module.exports, "YoutubeModal", function () { return $f29d6868cca9d48e$export$7283d5171aeba9eb; });

var $loA2J = parcelRequire("loA2J");

var $frRnC = parcelRequire("frRnC");
const $f29d6868cca9d48e$export$7283d5171aeba9eb = ({ isOpen: isOpen, closeModal: closeModal, src: src, title: title, closeIconLabel: closeIconLabel })=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $frRnC.Modal), {
        isOpen: isOpen,
        closeModal: closeModal,
        closeIconLabel: closeIconLabel,
        content: (height)=>/*#__PURE__*/ (0, $loA2J.jsx)("iframe", {
                style: {
                    verticalAlign: "bottom"
                },
                width: "100%",
                height: height,
                src: src,
                title: title,
                allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share",
                allowFullScreen: true,
                "data-gtm-yt-inspected-12": "true"
            })
    });
};

});
parcelRegister("frRnC", function(module, exports) {

$parcel$export(module.exports, "Modal", function () { return $905e08e2e5effdef$export$2b77a92f1a5ad772; });
/* modal.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $f6qj2 = parcelRequire("f6qj2");

var $6IiXU = parcelRequire("6IiXU");

var $f448m = parcelRequire("f448m");

var $8KELJ = parcelRequire("8KELJ");
var $hsvIJ = parcelRequire("hsvIJ");
var $bh8PA = parcelRequire("bh8PA");
const $905e08e2e5effdef$var$modalContentStyles = null;
const $905e08e2e5effdef$var$closeModalStyles = null;
const $905e08e2e5effdef$var$DESKTOP_MODAL_SIZE = {
    width: "large",
    // atlaskit modal starts ignoring the width at smaller sizes
    height: "540" // atlaskit modal starts setting height to 100% at smaller sizes
};
const $905e08e2e5effdef$var$MOBILE_MODAL_SIZE = {
    width: "1024px",
    height: "576"
};
const $905e08e2e5effdef$export$2b77a92f1a5ad772 = ({ isOpen: isOpen, closeModal: closeModal, content: content, closeIconLabel: closeIconLabel, isContentModal: isContentModal })=>{
    const intl = (0, $f6qj2.default)();
    const getModalSize = ()=>{
        if (window.innerWidth >= 1024) return $905e08e2e5effdef$var$MOBILE_MODAL_SIZE;
        return $905e08e2e5effdef$var$DESKTOP_MODAL_SIZE;
    };
    const [modalSize, setModalSize] = (0, $iSvIT.useState)(getModalSize());
    (0, $iSvIT.useEffect)(()=>{
        const updateModalSize = ()=>{
            setModalSize(getModalSize());
        };
        window.addEventListener("resize", updateModalSize);
        return ()=>window.removeEventListener("resize", updateModalSize);
    }, []);
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $bh8PA.default), {
        children: isOpen && /*#__PURE__*/ (0, $loA2J.jsxs)((0, $8KELJ.default), {
            onClose: closeModal,
            width: modalSize.width,
            height: modalSize.height,
            children: [
                window.innerWidth < 480 && /*#__PURE__*/ (0, $loA2J.jsx)((0, $hsvIJ.default), {
                    children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                        className: (0, $esG4f.default)([
                            "_1e0c1txw _1bsb1osq _1bahesu3 _jq8g1tcg"
                        ]),
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $6IiXU.default), {
                            appearance: "subtle-link",
                            onClick: closeModal,
                            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($f448m))), {
                                label: closeIconLabel !== null && closeIconLabel !== void 0 ? closeIconLabel : intl.formatMessage({
                                    id: "Modal.closeIconLabel",
                                    defaultMessage: "close modal"
                                })
                            })
                        })
                    })
                }),
                /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                    className: (0, $esG4f.default)([
                        "_4t3i1osq _1bsb1osq _kqswh2mm _8hk7glyw _19aezwfg _i09y7vkz _1m61zwfg _8sf87vkz _12hx1wug _jdwsyly2 _z8tz1h6o _1wrf1wug _1ov51wug _9ry81wug _puii1wug _1lzu1wug _9ep71osq _skrarbzz _1c221r31 _72u08stv _17ignqa1 _e133oelr _gqi51r31 _1jvzglyw _1y27nqa1 _3njzidpf _1qbr1wug _mw5fidpf _n9dy1wug _1qmd1e5h _iml01ns9 _1hbcidpf _12evidpf _1f2i1crf _n1p2idpf _1oq91bqd _mpw4bfng _1kb4viql _1nfb10nf _pvcxidpf _1a76dlk8 _1uxeyn4p _d09fzz36 _tyl97vkz _wjni1wto _nggt1k7u _onli1tcg _1el9stnw _u7yn1lpd _14g8kfja _4wwiu67f _1ogfglyw"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                            className: isContentModal ? "content-modal" : "",
                            children: content(getModalSize().height)
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                            id: "close-modal-button",
                            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $6IiXU.default), {
                                appearance: "subtle-link",
                                onClick: closeModal,
                                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($f448m))), {
                                    label: closeIconLabel !== null && closeIconLabel !== void 0 ? closeIconLabel : intl.formatMessage({
                                        id: "Modal.closeIconLabel",
                                        defaultMessage: "close modal"
                                    }),
                                    size: "xlarge"
                                })
                            })
                        })
                    ]
                })
            ]
        })
    });
};

});


parcelRegister("dABBq", function(module, exports) {

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $1UUq1 = parcelRequire("1UUq1");

var $frRnC = parcelRequire("frRnC");
const $687e0d918fce42d4$export$c6d2f0306728be42 = ({ text: text, content: content, isModalOpen: isModalOpen, setIsModalOpen: setIsModalOpen })=>{
    const [isOpen, setIsOpen] = (0, $iSvIT.useState)(false);
    // If state is passed in, use that instead of local state
    const isOpenState = isModalOpen ? isModalOpen : isOpen;
    const setIsOpenState = setIsModalOpen ? setIsModalOpen : setIsOpen;
    return /*#__PURE__*/ (0, $loA2J.jsxs)((0, $iSvIT.Fragment), {
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.Link), {
                href: "#",
                type: "modal",
                onClick: (event)=>{
                    event.preventDefault();
                    setIsOpenState(true);
                },
                text: text
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $frRnC.Modal), {
                content: content,
                closeModal: ()=>setIsOpenState(false),
                isOpen: isOpenState,
                isContentModal: true
            })
        ]
    });
};

});



parcelRegister("bP0EV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9d4affcf2ed5d193$export$2e2bcd8739ae039; });
/* content-types-section.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $f6qj2 = parcelRequire("f6qj2");

var $g9kzu = parcelRequire("g9kzu");

var $dyZbY = parcelRequire("dyZbY");

var $cutM5 = parcelRequire("cutM5");

var $7uljF = parcelRequire("7uljF");

var $iMdoL = parcelRequire("iMdoL");

var $ewrQo = parcelRequire("ewrQo");

var $enm66 = parcelRequire("enm66");

var $1uaLz = parcelRequire("1uaLz");

var $lCEMd = parcelRequire("lCEMd");

var $cGPaw = parcelRequire("cGPaw");

var $2nxiW = parcelRequire("2nxiW");

var $8croo = parcelRequire("8croo");

var $zxL92 = parcelRequire("zxL92");

var $7fb7E = parcelRequire("7fb7E");
const $9d4affcf2ed5d193$var$tabStyles = null;
const $9d4affcf2ed5d193$var$iconTabListStyles = null;
const $9d4affcf2ed5d193$var$iconTabStyles = null;
const $9d4affcf2ed5d193$var$opacityIn = null;
const $9d4affcf2ed5d193$var$contentContainer = null;
const $9d4affcf2ed5d193$export$375e4d9f76d4c766 = ({ isConfluenceCrossflow: isConfluenceCrossflow = false })=>{
    const intl = (0, $f6qj2.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $g9kzu.useAnalyticsEvents)();
    const { user: user } = (0, $iMdoL.useUserContext)();
    const tabList = [
        {
            title: intl.formatMessage((0, $7fb7E.tabbedHeroSectionPagesMessages).tabName),
            icon: /*#__PURE__*/ (0, $loA2J.jsx)((0, $enm66.PagesIcon), {
                width: "1.5em"
            }),
            content: (0, $2nxiW.PagesContentType),
            eventProps: {
                label: "content-type-tab-pages",
                labelEnglish: "Pages"
            }
        },
        {
            title: intl.formatMessage((0, $7fb7E.tabbedHeroSectionWhiteboardsMessages).tabName),
            icon: /*#__PURE__*/ (0, $loA2J.jsx)((0, $lCEMd.WhiteboardsIcon), {
                width: "1.5em"
            }),
            content: (0, $zxL92.WhiteboardsContentType),
            eventProps: {
                label: "content-type-tab-whiteboard",
                labelEnglish: "Whiteboards"
            }
        },
        {
            title: intl.formatMessage((0, $7fb7E.tabbedHeroSectionDatabasesMessages).tabName),
            icon: /*#__PURE__*/ (0, $loA2J.jsx)((0, $ewrQo.DatabasesIcon), {
                width: "1.5em"
            }),
            content: (0, $cGPaw.DatabasesContentType),
            eventProps: {
                label: "content-type-tab-databases",
                labelEnglish: "Databases"
            }
        },
        {
            title: intl.formatMessage((0, $7fb7E.tabbedHeroSectionSpacesMessages).tabName),
            icon: /*#__PURE__*/ (0, $loA2J.jsx)((0, $1uaLz.SpacesIcon), {
                width: "1.5em"
            }),
            content: (0, $8croo.SpacesContentType),
            eventProps: {
                label: "content-type-tab-spaces",
                labelEnglish: "Spaces"
            }
        }
    ];
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $dyZbY.default), {
        name: "confluence-pt-cfind-1234-contentTypesSection",
        children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
            className: (0, $esG4f.default)([
                "_p12f144l _195g1wug"
            ]),
            children: /*#__PURE__*/ (0, $loA2J.jsxs)((0, $cutM5.Adg4Tabs), {
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $cutM5.Adg4DraggableTabList), {
                        className: (0, $esG4f.default)([
                            "_1q51ftgi _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1bsb1osq _1bah1yb4 _owpu1tcg _1bhl7vkz _2osn7vkz"
                        ]),
                        children: tabList.map((tab, index)=>/*#__PURE__*/ {
                            var _tab_eventProps, _tab_eventProps1;
                            var _tab_eventProps_label;
                            return (0, $loA2J.jsx)((0, $cutM5.Adg4DraggableTab), {
                                dataEventProps: !isConfluenceCrossflow ? {
                                    "data-product-key": "confluence",
                                    "data-event": "clicked",
                                    "data-event-component": "tab",
                                    "data-event-container": "contentTypesSection",
                                    "data-label": (_tab_eventProps_label = (_tab_eventProps = tab.eventProps) === null || _tab_eventProps === void 0 ? void 0 : _tab_eventProps.label) !== null && _tab_eventProps_label !== void 0 ? _tab_eventProps_label : "content-type-tab",
                                    "data-label-english": (_tab_eventProps1 = tab.eventProps) === null || _tab_eventProps1 === void 0 ? void 0 : _tab_eventProps1.labelEnglish,
                                    "data-track-event": "confluence-pt.content-types.tab"
                                } : undefined,
                                onClick: ()=>{
                                    var _tab_eventProps_labelEnglish, _tab_eventProps, _user_extended_profile;
                                    if (!isConfluenceCrossflow) return;
                                    createAnalyticsEvent({
                                        eventName: "confluence-crossflow-content-types-tab-clicked",
                                        eventType: "ui",
                                        action: "clicked",
                                        actionSubject: "confluenceCrossflowTab",
                                        attributes: {
                                            reactComponent: "ContentTypesSection",
                                            tab: (_tab_eventProps = tab.eventProps) === null || _tab_eventProps === void 0 ? void 0 : (_tab_eventProps_labelEnglish = _tab_eventProps.labelEnglish) === null || _tab_eventProps_labelEnglish === void 0 ? void 0 : _tab_eventProps_labelEnglish.toLowerCase(),
                                            userTeamType: (_user_extended_profile = user.extended_profile) === null || _user_extended_profile === void 0 ? void 0 : _user_extended_profile.team_type
                                        }
                                    }).fire();
                                },
                                className: (0, $esG4f.default)([
                                    "_2rkoyh40"
                                ]),
                                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $7uljF.IconTab), {
                                    icon: tab.icon,
                                    title: tab.title,
                                    lozenge: tab.lozenge
                                })
                            }, index);
                        })
                    }),
                    tabList.map((tab, index)=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $cutM5.Adg4TabPanel), {
                            children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                className: (0, $esG4f.default)([
                                    "_1e0c1txw _2lx21bp4 _195g1wug _1q51zwfg _1tker5sb _owpu1tcg _o5kch9n0 _1bhl7vkz _xc2izwfg _j6qu12it _y44v1f3w"
                                ]),
                                children: /*#__PURE__*/ (0, $loA2J.jsx)(tab.content, {
                                    index: index,
                                    isConfluenceCrossflow: isConfluenceCrossflow
                                })
                            })
                        }, index))
                ]
            })
        })
    });
};
$9d4affcf2ed5d193$export$375e4d9f76d4c766.displayName = "ContentTypesSection";
var $9d4affcf2ed5d193$export$2e2bcd8739ae039 = $9d4affcf2ed5d193$export$375e4d9f76d4c766;

});
parcelRegister("7uljF", function(module, exports) {

$parcel$export(module.exports, "IconTab", function () { return $68f6e2ab0ae48e38$export$5fd6e91639893354; });
/* icon-tab.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $5ohHq = parcelRequire("5ohHq");
const $68f6e2ab0ae48e38$var$tabVerticalWrapper = null;
const $68f6e2ab0ae48e38$var$tabTextWrapper = null;
const $68f6e2ab0ae48e38$var$selectedTabStyle = null;
const $68f6e2ab0ae48e38$var$titleStyle = null;
const $68f6e2ab0ae48e38$var$lozengeStyle = null;
const $68f6e2ab0ae48e38$var$underline = null;
const $68f6e2ab0ae48e38$var$selectedUnderline = null;
const $68f6e2ab0ae48e38$export$5fd6e91639893354 = ({ isSelected: isSelected, icon: icon, title: title, lozenge: lozenge })=>{
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        className: (0, $esG4f.default)([
            "_1e0c1txw _2lx21bp4"
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                className: (0, $esG4f.default)([
                    "_1e0c1txw _4cvr1h6o _133i1crf _v736yh40 _chtu1y44 _16im7vkz _1wfq1y44 _15vtftgi _30l3jk2v _1xjmjk2v",
                    isSelected && "_syazjk2v _1yo9jk2v"
                ]),
                style: {
                    "--_1b67llw": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.extended.blue700"))
                },
                children: [
                    icon,
                    /*#__PURE__*/ (0, $loA2J.jsxs)("p", {
                        className: (0, $esG4f.default)([
                            "_1mouidpf _11cgftgi _1ywm7vkz",
                            "h4"
                        ]),
                        children: [
                            title,
                            lozenge && /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                                className: (0, $esG4f.default)([
                                    "_ahbqftgi _2rko1l7b _bfhk1ybm _syaz1ep1 _18zr1y44 _1p1dangw _1wyb1675 _vwz41j6v _k48pbfng _s7n4nkob"
                                ]),
                                style: {
                                    "--_1hkddbi": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.extended.blue100")),
                                    "--_1pjqntz": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.extended.blue800"))
                                },
                                children: lozenge
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_1e0c1txw _4t3i1y44 _2rkoyh40",
                    isSelected && "_bfhkjk2v"
                ]),
                style: {
                    "--_1b67llw": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.extended.blue700"))
                }
            })
        ]
    });
};

});

parcelRegister("ewrQo", function(module, exports) {

$parcel$export(module.exports, "DatabasesIcon", function () { return $b21aa706901ff38f$export$4fe34b71b973310d; });

var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");
const $b21aa706901ff38f$export$4fe34b71b973310d = (props)=>/*#__PURE__*/ (0, $loA2J.jsx)("svg", (0, $6iHNw._)((0, $7Knp0._)({
        width: 28,
        viewBox: "1 0 28 28",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: /*#__PURE__*/ (0, $loA2J.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M28.9465 21.5V28H16.4465V21.5H28.9465ZM28.9465 18.5V12.5H16.4465V18.5H28.9465ZM28.9465 9.5V0H0.946533V9.5H28.9465ZM0.946533 12.5V18.5H13.4465V12.5H0.946533ZM0.946533 21.5H13.4465V28H0.946533V21.5Z",
            fill: "currentColor"
        })
    }));

});

parcelRegister("enm66", function(module, exports) {

$parcel$export(module.exports, "PagesIcon", function () { return $f7ba8ebb7a3b81ad$export$34791a62a45c026; });

var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");
const $f7ba8ebb7a3b81ad$export$34791a62a45c026 = (props)=>/*#__PURE__*/ (0, $loA2J.jsxs)("svg", (0, $6iHNw._)((0, $7Knp0._)({
        width: 31,
        viewBox: "0 0 31 29",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M.947 0h22v22h-22zm17 6h-12v3h12zm0 7h-12v3h12z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M26.947 9v16h-16v4h20V9z",
                fill: "currentColor"
            })
        ]
    }));

});

parcelRegister("1uaLz", function(module, exports) {

$parcel$export(module.exports, "SpacesIcon", function () { return $9077e02e0d0eb244$export$90df9698aa84700a; });

var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");
const $9077e02e0d0eb244$export$90df9698aa84700a = (props)=>/*#__PURE__*/ (0, $loA2J.jsx)("svg", (0, $6iHNw._)((0, $7Knp0._)({
        width: 28,
        viewBox: "1 0 28 28",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: /*#__PURE__*/ (0, $loA2J.jsx)("path", {
            d: "M15.695 0a4 4 0 0 0-4 4v20a4 4 0 0 0 4 4h9a4 4 0 0 0 4-4V4a4 4 0 0 0-4-4zm-15 8h8V4h-8zm0 16h8v-4h-8zm0-12h8v4h-8z",
            fill: "currentColor"
        })
    }));

});

parcelRegister("lCEMd", function(module, exports) {

$parcel$export(module.exports, "WhiteboardsIcon", function () { return $2f5f45b21e73b991$export$5dab50d99c45ffad; });

var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");
const $2f5f45b21e73b991$export$5dab50d99c45ffad = (props)=>/*#__PURE__*/ (0, $loA2J.jsx)("svg", (0, $6iHNw._)((0, $7Knp0._)({
        width: 27,
        height: 27,
        viewBox: "0 0 27 27",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: /*#__PURE__*/ (0, $loA2J.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M13.24 5.793c.292-.874 1.284-1.802 2.57-2.296 1.347-.518 2.264-.305 2.602.033.19.191.194.293.194.327.002.078-.025.257-.205.56-.382.643-1.123 1.335-1.941 2.05l-.182.16c-.318.276-.648.564-.903.815a4 4 0 0 0-.47.538c-.11.154-.38.554-.375 1.095.003.32.101.65.318.937.203.268.451.42.644.508.354.16.724.188.976.195.545.014 1.292-.073 2.232-.23 2.577-.429 3.984.226 4.511.878.438.541.651 1.602-.523 3.168l2.25 1.688c1.638-2.184 1.992-4.73.46-6.624-1.252-1.549-3.43-2.211-5.978-2.026.515-.51 1.03-1.094 1.4-1.716.334-.565.62-1.272.598-2.07-.023-.842-.382-1.606-1.017-2.241C18.864.005 16.499.218 14.8.872c-1.761.677-3.581 2.093-4.228 4.032zm-6.302 14.27a6.562 6.562 0 1 0 0-13.125 6.562 6.562 0 0 0 0 13.125m0-2.813a3.75 3.75 0 1 0 0-7.5 3.75 3.75 0 0 0 0 7.5m10.781-2.812c.494 0 .951.259 1.206.682l5.625 9.375a1.406 1.406 0 0 1-1.206 2.13h-11.25a1.406 1.406 0 0 1-1.206-2.13l5.625-9.375a1.4 1.4 0 0 1 1.206-.682m3.141 9.375-3.141-5.236-3.142 5.235z",
            fill: "currentColor"
        })
    }));

});

parcelRegister("cGPaw", function(module, exports) {

$parcel$export(module.exports, "DatabasesContentType", function () { return $7d67a8f4af727eb2$export$abd9e762d8d9ba66; });

var $loA2J = parcelRequire("loA2J");

var $f6qj2 = parcelRequire("f6qj2");

var $g9kzu = parcelRequire("g9kzu");

var $850Fj = parcelRequire("850Fj");

var $cutM5 = parcelRequire("cutM5");

var $2ompn = parcelRequire("2ompn");

var $1UUq1 = parcelRequire("1UUq1");

var $3FBn4 = parcelRequire("3FBn4");

var $7fb7E = parcelRequire("7fb7E");

var $f8LoV = parcelRequire("f8LoV");
const $7d67a8f4af727eb2$export$abd9e762d8d9ba66 = ({ index: index, isConfluenceCrossflow: isConfluenceCrossflow })=>{
    const { isCurrentTab: isCurrentTab } = (0, $cutM5.useAdg4TabsContext)();
    const intl = (0, $f6qj2.default)();
    const ctaLink = (0, $3FBn4.useLocalizedHref)("/software/confluence/databases");
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $g9kzu.useAnalyticsEvents)();
    const { user: user } = (0, $2ompn.useUserContext)();
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $f8LoV.ContentTypeVideo), {
        active: isCurrentTab(index),
        title: intl.formatMessage((0, $7fb7E.tabbedHeroSectionDatabasesMessages).contentTitle),
        description: intl.formatMessage((0, $7fb7E.tabbedHeroSectionDatabasesMessages).contentDescription),
        iconTitle: intl.formatMessage((0, $7fb7E.tabbedHeroSectionDatabasesMessages).contentIconTitle),
        iconCollection: [
            {
                description: intl.formatMessage((0, $7fb7E.tabbedHeroSectionDatabasesMessages).contentFeaturePoint1),
                icon: /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($850Fj))), {
                    size: "small",
                    label: ""
                })
            },
            {
                description: intl.formatMessage((0, $7fb7E.tabbedHeroSectionDatabasesMessages).contentFeaturePoint2),
                icon: /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($850Fj))), {
                    size: "small",
                    label: ""
                })
            },
            {
                description: intl.formatMessage((0, $7fb7E.tabbedHeroSectionDatabasesMessages).contentFeaturePoint3),
                icon: /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($850Fj))), {
                    size: "small",
                    label: ""
                })
            }
        ],
        cta: /*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.Link), {
            href: ctaLink,
            text: intl.formatMessage((0, $7fb7E.tabbedHeroSectionDatabasesMessages).contentCta),
            type: "primary",
            dataEventProps: !isConfluenceCrossflow ? {
                "data-product-key": "confluence",
                "data-event-component": "linkButton",
                "data-event-container": "contentTypesSection",
                "data-event": "clicked",
                "data-label": "explore-databases",
                "data-label-english": "Explore Databases",
                "data-track-event": "confluence-pt.content-types.databases.cta"
            } : undefined,
            onClick: ()=>{
                var _user_extended_profile;
                if (!isConfluenceCrossflow) return;
                createAnalyticsEvent({
                    eventName: "confluence-crossflow-tab-cta-clicked",
                    eventType: "ui",
                    action: "clicked",
                    actionSubject: "linkButton",
                    actionSubjectId: "confluenceCrossFlowHeroSection",
                    attributes: {
                        reactComponent: "DatabasesContentType",
                        tab: "databases",
                        userTeamType: (_user_extended_profile = user.extended_profile) === null || _user_extended_profile === void 0 ? void 0 : _user_extended_profile.team_type
                    }
                }).fire();
            }
        }),
        reverseLayout: true,
        videoSrcMp4: "https://wac-cdn.atlassian.com/misc-assets/videos/confluence-product-tour/PT_CT_Databases_LowBR_reencode.mp4",
        videoSrcWebm: "https://wac-cdn.atlassian.com/misc-assets/videos/confluence-product-tour/PT_CT_Databases_LowBR.webm",
        videoPreviewSrc: "https://wac-cdn.atlassian.com/misc-assets/webp-images/confluence/PT_CT_Databases_Preview.webp"
    });
};

});
parcelRegister("850Fj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5e1f4e7de5e35f86$var$_react = $5e1f4e7de5e35f86$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $h5zK0 = parcelRequire("h5zK0");
function $5e1f4e7de5e35f86$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $5e1f4e7de5e35f86$var$PresenceActiveIcon = (props)=>/*#__PURE__*/ $5e1f4e7de5e35f86$var$_react.default.createElement($h5zK0.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><circle cx="12" cy="12" r="6" fill="currentcolor" fill-rule="evenodd"/></svg>`
    }, props));
$5e1f4e7de5e35f86$var$PresenceActiveIcon.displayName = "PresenceActiveIcon";
var $5e1f4e7de5e35f86$var$_default = module.exports.default = $5e1f4e7de5e35f86$var$PresenceActiveIcon;

});


parcelRegister("2nxiW", function(module, exports) {

$parcel$export(module.exports, "PagesContentType", function () { return $b6acef8ec87fc2b9$export$3914470415d96f5f; });
/* pages-content-type.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $f6qj2 = parcelRequire("f6qj2");

var $g9kzu = parcelRequire("g9kzu");

var $850Fj = parcelRequire("850Fj");

var $cutM5 = parcelRequire("cutM5");

var $2ompn = parcelRequire("2ompn");

var $1UUq1 = parcelRequire("1UUq1");

var $7fb7E = parcelRequire("7fb7E");

var $f8LoV = parcelRequire("f8LoV");
const $b6acef8ec87fc2b9$var$hideMobile = null;
const $b6acef8ec87fc2b9$export$3914470415d96f5f = ({ index: index, isConfluenceCrossflow: isConfluenceCrossflow })=>{
    const { isCurrentTab: isCurrentTab } = (0, $cutM5.useAdg4TabsContext)();
    const intl = (0, $f6qj2.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $g9kzu.useAnalyticsEvents)();
    const { user: user } = (0, $2ompn.useUserContext)();
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $f8LoV.ContentTypeVideo), {
        active: isCurrentTab(index),
        title: intl.formatMessage((0, $7fb7E.tabbedHeroSectionPagesMessages).contentTitle),
        description: intl.formatMessage((0, $7fb7E.tabbedHeroSectionPagesMessages).contentDescription),
        iconTitle: intl.formatMessage((0, $7fb7E.tabbedHeroSectionPagesMessages).contentIconTitle),
        iconCollection: [
            {
                description: intl.formatMessage((0, $7fb7E.tabbedHeroSectionPagesMessages).contentFeaturePoint1),
                icon: /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($850Fj))), {
                    size: "small",
                    label: ""
                })
            },
            {
                description: intl.formatMessage((0, $7fb7E.tabbedHeroSectionPagesMessages).contentFeaturePoint2),
                icon: /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($850Fj))), {
                    size: "small",
                    label: ""
                })
            },
            {
                description: intl.formatMessage((0, $7fb7E.tabbedHeroSectionPagesMessages).contentFeaturePoint3),
                icon: /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($850Fj))), {
                    size: "small",
                    label: ""
                })
            }
        ],
        cta: intl.locale === "en" ? /*#__PURE__*/ (0, $loA2J.jsx)("div", {
            className: (0, $esG4f.default)([
                "_1mjbglyw"
            ]),
            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.Link), {
                href: "https://www.atlassian.com/confluence-sandbox-editor",
                text: intl.formatMessage((0, $7fb7E.tabbedHeroSectionPagesMessages).contentCta),
                type: "primary",
                dataEventProps: !isConfluenceCrossflow ? {
                    "data-product-key": "confluence",
                    "data-event-component": "linkButton",
                    "data-event-container": "contentTypesSection",
                    "data-event": "clicked",
                    "data-label": "try-it-out",
                    "data-label-english": "Try it out",
                    "data-track-event": "confluence-pt.content-types.pages.cta"
                } : undefined,
                onClick: ()=>{
                    var _user_extended_profile;
                    if (!isConfluenceCrossflow) return;
                    createAnalyticsEvent({
                        eventName: "confluence-crossflow-tab-cta-clicked",
                        eventType: "ui",
                        action: "clicked",
                        actionSubject: "linkButton",
                        actionSubjectId: "confluenceCrossFlowHeroSection",
                        attributes: {
                            reactComponent: "PagesContentType",
                            tab: "pages",
                            userTeamType: (_user_extended_profile = user.extended_profile) === null || _user_extended_profile === void 0 ? void 0 : _user_extended_profile.team_type
                        }
                    }).fire();
                }
            })
        }) : undefined,
        reverseLayout: true,
        videoSrcMp4: "https://wac-cdn.atlassian.com/misc-assets/videos/confluence-product-tour/PT_CT_Pages_LowBR_reencode.mp4",
        videoSrcWebm: "https://wac-cdn.atlassian.com/misc-assets/videos/confluence-product-tour/PT_CT_Pages_LowBR.webm",
        videoPreviewSrc: "https://wac-cdn.atlassian.com/misc-assets/webp-images/confluence/PT_CT_Pages_Preview.webp"
    });
};

});

parcelRegister("8croo", function(module, exports) {

$parcel$export(module.exports, "SpacesContentType", function () { return $7b4abea5b5c6ed63$export$31e6bce70211a7b2; });

var $loA2J = parcelRequire("loA2J");

var $f6qj2 = parcelRequire("f6qj2");

var $g9kzu = parcelRequire("g9kzu");

var $850Fj = parcelRequire("850Fj");

var $cutM5 = parcelRequire("cutM5");

var $2ompn = parcelRequire("2ompn");

var $1UUq1 = parcelRequire("1UUq1");

var $3FBn4 = parcelRequire("3FBn4");

var $7fb7E = parcelRequire("7fb7E");

var $f8LoV = parcelRequire("f8LoV");
const $7b4abea5b5c6ed63$export$31e6bce70211a7b2 = ({ index: index, isConfluenceCrossflow: isConfluenceCrossflow })=>{
    const { isCurrentTab: isCurrentTab } = (0, $cutM5.useAdg4TabsContext)();
    const intl = (0, $f6qj2.default)();
    const ctaLink = (0, $3FBn4.useLocalizedHref)("/software/confluence/use-cases/knowledge-management-software");
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $g9kzu.useAnalyticsEvents)();
    const { user: user } = (0, $2ompn.useUserContext)();
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $f8LoV.ContentTypeVideo), {
        active: isCurrentTab(index),
        title: intl.formatMessage((0, $7fb7E.tabbedHeroSectionSpacesMessages).contentTitle),
        description: intl.formatMessage((0, $7fb7E.tabbedHeroSectionSpacesMessages).contentDescription),
        iconTitle: intl.formatMessage((0, $7fb7E.tabbedHeroSectionSpacesMessages).contentIconTitle),
        iconCollection: [
            {
                description: intl.formatMessage((0, $7fb7E.tabbedHeroSectionSpacesMessages).contentFeaturePoint1),
                icon: /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($850Fj))), {
                    size: "small",
                    label: ""
                })
            },
            {
                description: intl.formatMessage((0, $7fb7E.tabbedHeroSectionSpacesMessages).contentFeaturePoint2),
                icon: /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($850Fj))), {
                    size: "small",
                    label: ""
                })
            },
            {
                description: intl.formatMessage((0, $7fb7E.tabbedHeroSectionSpacesMessages).contentFeaturePoint3),
                icon: /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($850Fj))), {
                    size: "small",
                    label: ""
                })
            }
        ],
        cta: /*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.Link), {
            href: ctaLink,
            text: intl.formatMessage((0, $7fb7E.tabbedHeroSectionSpacesMessages).contentCta),
            type: "primary",
            dataEventProps: !isConfluenceCrossflow ? {
                "data-product-key": "confluence",
                "data-event-component": "linkButton",
                "data-event-container": "contentTypesSection",
                "data-event": "clicked",
                "data-label": "explore-knowledge-sharing",
                "data-label-english": "Explore knowledge sharing",
                "data-track-event": "confluence-pt.content-types.spaces.cta"
            } : undefined,
            onClick: ()=>{
                var _user_extended_profile;
                if (!isConfluenceCrossflow) return;
                createAnalyticsEvent({
                    eventName: "confluence-crossflow-tab-cta-clicked",
                    eventType: "ui",
                    action: "clicked",
                    actionSubject: "linkButton",
                    actionSubjectId: "confluenceCrossFlowHeroSection",
                    attributes: {
                        reactComponent: "SpacesContentType",
                        tab: "spaces",
                        userTeamType: (_user_extended_profile = user.extended_profile) === null || _user_extended_profile === void 0 ? void 0 : _user_extended_profile.team_type
                    }
                }).fire();
            }
        }),
        reverseLayout: true,
        videoSrcMp4: "https://wac-cdn.atlassian.com/misc-assets/videos/confluence-product-tour/PT_CT_Spaces_LowBR_reencode.mp4",
        videoSrcWebm: "https://wac-cdn.atlassian.com/misc-assets/videos/confluence-product-tour/PT_CT_Spaces_LowBR.webm",
        videoPreviewSrc: "https://wac-cdn.atlassian.com/misc-assets/webp-images/confluence/PT_CT_Spaces_Preview.webp"
    });
};

});

parcelRegister("zxL92", function(module, exports) {

$parcel$export(module.exports, "WhiteboardsContentType", function () { return $79bc201f7bede7ec$export$163a1257b16e076f; });

var $loA2J = parcelRequire("loA2J");

var $f6qj2 = parcelRequire("f6qj2");

var $g9kzu = parcelRequire("g9kzu");

var $850Fj = parcelRequire("850Fj");

var $cutM5 = parcelRequire("cutM5");

var $2ompn = parcelRequire("2ompn");

var $1UUq1 = parcelRequire("1UUq1");

var $3FBn4 = parcelRequire("3FBn4");

var $7fb7E = parcelRequire("7fb7E");

var $f8LoV = parcelRequire("f8LoV");
const $79bc201f7bede7ec$export$163a1257b16e076f = ({ index: index, isConfluenceCrossflow: isConfluenceCrossflow })=>{
    const { isCurrentTab: isCurrentTab } = (0, $cutM5.useAdg4TabsContext)();
    const intl = (0, $f6qj2.default)();
    const ctaLink = (0, $3FBn4.useLocalizedHref)("/software/confluence/whiteboards");
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $g9kzu.useAnalyticsEvents)();
    const { user: user } = (0, $2ompn.useUserContext)();
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $f8LoV.ContentTypeVideo), {
        active: isCurrentTab(index),
        title: intl.formatMessage((0, $7fb7E.tabbedHeroSectionWhiteboardsMessages).contentTitle),
        description: intl.formatMessage((0, $7fb7E.tabbedHeroSectionWhiteboardsMessages).contentDescription),
        iconTitle: intl.formatMessage((0, $7fb7E.tabbedHeroSectionWhiteboardsMessages).contentIconTitle),
        iconCollection: [
            {
                description: intl.formatMessage((0, $7fb7E.tabbedHeroSectionWhiteboardsMessages).contentFeaturePoint1),
                icon: /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($850Fj))), {
                    size: "small",
                    label: ""
                })
            },
            {
                description: intl.formatMessage((0, $7fb7E.tabbedHeroSectionWhiteboardsMessages).contentFeaturePoint2),
                icon: /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($850Fj))), {
                    size: "small",
                    label: ""
                })
            },
            {
                description: intl.formatMessage((0, $7fb7E.tabbedHeroSectionWhiteboardsMessages).contentFeaturePoint3),
                icon: /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($850Fj))), {
                    size: "small",
                    label: ""
                })
            }
        ],
        cta: /*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.Link), {
            href: ctaLink,
            text: intl.formatMessage((0, $7fb7E.tabbedHeroSectionWhiteboardsMessages).contentCta),
            type: "primary",
            dataEventProps: !isConfluenceCrossflow ? {
                "data-product-key": "confluence",
                "data-event-component": "linkButton",
                "data-event-container": "contentTypesSection",
                "data-event": "clicked",
                "data-label": "explore-whiteboards",
                "data-label-english": "Explore Whiteboards",
                "data-track-event": "confluence-pt.content-types.whiteboards.cta"
            } : undefined,
            onClick: ()=>{
                var _user_extended_profile;
                if (!isConfluenceCrossflow) return;
                createAnalyticsEvent({
                    eventName: "confluence-crossflow-tab-cta-clicked",
                    eventType: "ui",
                    action: "clicked",
                    actionSubject: "linkButton",
                    actionSubjectId: "confluenceCrossFlowHeroSection",
                    attributes: {
                        reactComponent: "WhiteboardsContentType",
                        tab: "whiteboards",
                        userTeamType: (_user_extended_profile = user.extended_profile) === null || _user_extended_profile === void 0 ? void 0 : _user_extended_profile.team_type
                    }
                }).fire();
            }
        }),
        reverseLayout: true,
        videoSrcMp4: "https://wac-cdn.atlassian.com/misc-assets/videos/confluence-product-tour/PT_CT_Whiteboards_LowBR_reencode.mp4",
        videoSrcWebm: "https://wac-cdn.atlassian.com/misc-assets/videos/confluence-product-tour/PT_CT_Whiteboards_LowBR.webm",
        videoPreviewSrc: "https://wac-cdn.atlassian.com/misc-assets/webp-images/confluence/PT_CT_Whiteboards_Preview.webp"
    });
};

});


parcelRegister("662uD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6cb411983b263af0$export$2e2bcd8739ae039; });
/* cta-section.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $dFnC9 = parcelRequire("dFnC9");

var $dyZbY = parcelRequire("dyZbY");

var $i8kxh = parcelRequire("i8kxh");
parcelRequire("336el");
var $daJhf = parcelRequire("daJhf");

var $91nJf = parcelRequire("91nJf");

var $3LLDq = parcelRequire("3LLDq");

var $f0Hih = parcelRequire("f0Hih");

var $3FBn4 = parcelRequire("3FBn4");
const $6cb411983b263af0$var$sectionContainer = null;
const $6cb411983b263af0$var$contentContainer = null;
const $6cb411983b263af0$var$backgroundBlue = null;
const $6cb411983b263af0$var$backgroundYellow = null;
const $6cb411983b263af0$var$textSection = null;
const $6cb411983b263af0$var$headingText = null;
const $6cb411983b263af0$var$subText = null;
const $6cb411983b263af0$var$graphicSection = null;
const $6cb411983b263af0$var$replacesStyle = null;
const $6cb411983b263af0$var$CtaSection = ()=>{
    const signupLink = (0, $3FBn4.useLocalizedHref)("/try/cloud/signup?bundle=confluence");
    const { openCrossFlow: openCrossFlow } = (0, $3LLDq.useCrossFlowFrontendTouchpoint)({
        productKey: (0, $i8kxh.ProductKeys).CONFLUENCE,
        edition: (0, $i8kxh.Editions).FREE,
        redirectUrl: signupLink
    });
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $dyZbY.default), {
        name: "confluence-pt-cfind-1234-ctaSection",
        children: /*#__PURE__*/ (0, $loA2J.jsxs)("section", {
            className: (0, $esG4f.default)([
                "_kqswh2mm _1e0c1txw _1bah1h6o _19pkidpf _2hwx1wug _otyridpf _18u01wug _p12f1rd8 _1tke1784 _1reo15vq _18m915vq"
            ]),
            children: [
                /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                    className: (0, $esG4f.default)([
                        "_kqswstnw _mkrz1ak8 _bfhkkizl _1ul91rd8 _1bsb1osq _4t3i1osq _152tidpf _u7coidpf _blhd1osq _197p5cbm"
                    ])
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                    className: (0, $esG4f.default)([
                        "_kqswstnw _mkrz116y _bfhkdoyu _1ul91rd8 _1bsb1osq _4t3i1osq _152tidpf _u7coidpf _blhd1osq _197p8ehm"
                    ])
                }),
                /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                    className: (0, $esG4f.default)([
                        "_kqswh2mm _1e0c1txw _2lx2vrvc _p12f1fra _19pk1wug _2hwx1wug _otyr1wug _18u01wug _bozgvbgk _y4tivbgk _1q5116xz _85i516xz _zulpzwfg _na0i1bp4 _2osn1wqb _144t1k7u _xc2i1fqw"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                            className: (0, $esG4f.default)([
                                "_gu181h6o _8fz61c5i"
                            ]),
                            children: [
                                /*#__PURE__*/ (0, $loA2J.jsx)("h2", {
                                    className: (0, $esG4f.default)([
                                        "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _syaz12cp _uqyg1k8s"
                                    ]),
                                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                                        id: "ConfluenceSoftwarePage.v4.ctaSection.header",
                                        defaultMessage: "Ditch your old docs, collaborate effortlessly with Confluence"
                                    })
                                }),
                                /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                                    className: (0, $esG4f.default)([
                                        "_1pfhoqnp _6rth1k8s _p12f1sxm _syaz12cp _1fkk1wug _8fz61sum"
                                    ]),
                                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                                        id: "ConfluenceSoftwarePage.v4.ctaSection.subtext",
                                        defaultMessage: "Confluence is your connected workspace, designed for collaboration and built to last"
                                    })
                                }),
                                /*#__PURE__*/ (0, $loA2J.jsx)((0, $f0Hih.default), {
                                    intentType: "button",
                                    containerId: "ctaSection",
                                    productKey: "confluence",
                                    edition: "free",
                                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $91nJf.Adg4Button), {
                                        href: signupLink,
                                        variant: "primary",
                                        color: "yellow",
                                        size: "large",
                                        onClick: openCrossFlow,
                                        dataEventProps: {
                                            "data-product-key": "confluence",
                                            "data-event": "clicked",
                                            "data-event-component": "linkButton",
                                            "data-event-container": "ctaSection",
                                            "data-label": "cta-get-confluence-free",
                                            "data-label-english": "Get Confluence free",
                                            "data-track-event": "confluence-pt.cta.get-confluence-free"
                                        },
                                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                                            id: "ConfluenceSoftwarePage.v4.heroCTA",
                                            defaultMessage: "Get Confluence free"
                                        })
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                            className: (0, $esG4f.default)([
                                "_1e0c1txw _2lx21bp4 _1bah1h6o _4cvr1h6o _16jlidpf _1o9zidpf _i0dlhwvj"
                            ]),
                            children: [
                                /*#__PURE__*/ (0, $loA2J.jsx)((0, $f0Hih.default), {
                                    intentType: "button",
                                    containerId: "ctaSection",
                                    productKey: "confluence",
                                    edition: "free",
                                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $daJhf.AnimatedButtonArrows), {
                                        product: "confluence",
                                        href: signupLink,
                                        onClick: openCrossFlow,
                                        color: "#fff"
                                    })
                                }),
                                /*#__PURE__*/ (0, $loA2J.jsx)("img", {
                                    src: "https://wac-cdn.atlassian.com/misc-assets/webp-images/confluence/confluencelp-replaces.webp",
                                    alt: "",
                                    role: "presentation",
                                    className: (0, $esG4f.default)([
                                        "_1pfh8pqr _tzy4q80t _1o2w1lyw _lcxvglyw"
                                    ])
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
$6cb411983b263af0$var$CtaSection.displayName = "CtaSection";
var $6cb411983b263af0$export$2e2bcd8739ae039 = $6cb411983b263af0$var$CtaSection;

});
parcelRegister("336el", function(module, exports) {
$parcel$export(module.exports, "AnimatedButtonArrows", function () { return (parcelRequire("daJhf")).AnimatedButtonArrows; });
parcelRequire("daJhf");

});
parcelRegister("daJhf", function(module, exports) {

$parcel$export(module.exports, "AnimatedButtonArrows", function () { return $56bb6720dc6421ba$export$554aaec702debd9a; });
/* animated-button-arrows.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7Knp0 = parcelRequire("7Knp0");

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $eDoPe = parcelRequire("eDoPe");

var $4XrxY = parcelRequire("4XrxY");
const $56bb6720dc6421ba$var$animatedContainer = null;
const $56bb6720dc6421ba$var$arrowStyle = null;
const $56bb6720dc6421ba$var$arrowsContainer = null;
const $56bb6720dc6421ba$export$8941bb92081bfaa5 = (props)=>{
    const arrowInlineStyle = null;
    var _props_rotate, _props_translateX, _props_translateY;
    return /*#__PURE__*/ (0, $loA2J.jsx)("svg", {
        width: "52",
        height: "17",
        viewBox: "0 0 72 25",
        xmlns: "http://www.w3.org/2000/svg",
        className: (0, $esG4f.default)([
            "_kqswstnw _5sag9cwz _tip8kb7n _1o51eoah",
            "_1e021mv2 _rjxp1afg _152tl7rb _t9ecwv2z",
            props.animate && "_j7hqgx4m"
        ]),
        style: {
            color: props.color ? props.color : "currentColor",
            visibility: props.animate ? "visible" : "hidden",
            "--_11zanbc": (0, $43MIc.default)(props.left),
            "--_c7a5uq": (0, $43MIc.default)(props.right),
            "--_kmwll6": (0, $43MIc.default)(props.top),
            "--_l8fg41": (0, $43MIc.default)((_props_rotate = props.rotate) !== null && _props_rotate !== void 0 ? _props_rotate : 0, "deg"),
            "--_r2j83y": (0, $43MIc.default)((_props_translateX = props.translateX) !== null && _props_translateX !== void 0 ? _props_translateX : "0%"),
            "--_1y23j83": (0, $43MIc.default)((_props_translateY = props.translateY) !== null && _props_translateY !== void 0 ? _props_translateY : "0%")
        },
        children: /*#__PURE__*/ (0, $loA2J.jsx)("path", {
            d: "M59.9377 15.3992C59.0173 14.9197 58.1224 14.8026 57.2375 14.6506C56.2764 14.4847 55.3298 14.5122 54.3661 14.6939C53.5179 14.8575 52.6572 14.756 51.8548 14.5047C50.3545 14.0308 48.8161 13.9548 47.2581 13.9487C46.2852 13.9435 45.2992 13.8949 44.3421 13.7474C43.6788 13.6425 43.0503 13.3313 42.3766 13.1053C41.985 13.7302 41.3847 13.7038 40.7654 13.4715C39.4868 12.9907 38.1709 12.9018 36.8181 12.9291C36.0821 12.9425 35.3546 12.7709 34.7504 12.2942C34.6729 12.2382 34.5745 12.21 34.4827 12.1765C33.8726 12.7787 33.1602 12.7406 32.4202 12.5737C31.2308 12.3121 30.0329 12.0735 28.8435 11.8119C28.0392 11.6324 27.2369 11.435 26.434 11.2435C25.6375 11.0468 24.8746 10.7635 24.004 10.9669C22.9249 11.2205 21.8431 10.958 20.7692 10.7864C19.5431 10.5869 18.3301 10.2689 17.1034 10.1833C15.0061 10.0312 12.9448 9.66091 10.8685 9.37304C9.87464 9.2337 8.87682 9.12994 7.89344 8.94972C6.89235 8.76766 5.89651 8.53817 4.91509 8.28619C3.86938 8.02152 2.82958 7.7035 1.79371 7.40388C1.12194 7.21408 0.740116 6.67063 0.443572 6.11206C0.359595 5.95341 0.591152 5.53371 0.780077 5.33746C1.3744 4.71561 2.13013 4.41639 2.99148 4.35003C4.92541 4.19732 6.85018 4.28953 8.7651 4.47067C10.4852 4.63154 12.1902 4.92878 13.8886 5.23134C15.8515 5.57338 17.8274 5.79684 19.8165 5.95571C21.368 6.07507 22.9135 6.30175 24.4618 6.45076C25.9089 6.59525 27.3614 6.69231 28.8151 6.83149C30.4224 6.98663 32.0303 7.13584 33.6388 7.3331C35.9198 7.60628 38.1897 7.92627 40.47 8.20538C42.0904 8.40386 43.7114 8.59642 45.3646 8.49847C46.3027 8.4401 47.2618 8.62379 48.1927 8.79256C49.5336 9.03394 50.885 9.07253 52.239 9.14136C53.8902 9.22311 55.5421 9.29894 57.1985 9.38723C57.6735 9.41263 58.1432 9.48547 58.6182 9.51087C58.7481 9.52438 58.8865 9.46081 59.0203 9.43874C58.9685 9.31341 58.9514 9.14372 58.8583 9.06807C58.3052 8.61476 57.7305 8.19518 57.1775 7.74187C55.7106 6.53386 54.2437 5.32585 52.784 4.1066C52.2211 3.63427 51.8989 2.98308 51.5571 2.34784C51.3492 1.9604 51.5341 1.63781 51.7218 1.34547C51.9021 1.06438 52.0235 0.669208 52.4453 0.635111C52.7346 0.611222 53.0239 0.587334 53.3159 0.593703C54.7643 0.618392 56.0541 1.16031 57.3235 1.77807C58.2302 2.22017 59.1204 2.70255 60.0415 3.12217C60.4279 3.30028 60.6627 3.55259 60.8241 3.92919C60.9383 4.19293 61.0275 4.52005 61.4388 4.203C61.6212 4.06605 61.8429 4.11309 62.0102 4.32839C62.2563 4.64183 62.5469 4.92992 62.7922 5.24929C62.9589 5.47051 63.1498 5.52635 63.422 5.54866C64.448 5.61337 65.2517 6.12273 65.8284 6.95631C66.199 7.4926 66.6963 7.85616 67.2599 8.10666C67.9146 8.39663 68.5004 8.76939 68.9623 9.29118C69.8119 10.2491 70.6155 11.2442 71.4126 12.2446C71.7531 12.6758 71.6567 13.4934 71.2651 13.9024C70.5625 14.639 69.8337 15.3428 69.1476 16.093C68.7802 16.4986 68.4883 16.978 68.1472 17.4163C68.0081 17.5937 67.8625 17.8305 67.6703 17.8944C66.9192 18.1522 66.4311 18.7311 65.8676 19.2362C65.6354 19.4459 65.3887 19.6782 65.1073 19.7928C64.1935 20.1716 63.2705 20.5253 62.3343 20.8358C62.0614 20.9274 61.7282 20.8087 61.4231 20.813C61.2854 20.8167 61.0794 20.8432 61.0217 20.9332C60.5146 21.738 59.7602 22.1333 58.8588 22.1835C57.4825 22.2623 56.1856 22.7031 54.8565 23.0027C53.3253 23.3472 51.7949 23.6858 50.267 24.0547C49.0888 24.34 47.9008 24.4443 46.6976 24.4151C46.1853 24.4038 45.8133 24.1493 45.6316 23.7406C45.2412 22.8424 45.1435 22.8622 45.7706 22.0519C45.8893 21.8963 46.0244 21.7544 46.1209 21.5846C46.4935 20.9157 47.1521 20.7922 47.8029 20.5781C48.9181 20.2143 50.011 19.7822 51.0986 19.3436C52.5241 18.7662 53.93 18.1508 55.345 17.5603C56.1092 17.2379 56.8866 16.959 57.6358 16.6111C58.3849 16.2632 59.1046 15.8583 59.9219 15.4335L59.9377 15.3992Z",
            fill: "currentColor"
        })
    });
};
const $56bb6720dc6421ba$var$buttonStyle = null;
const $56bb6720dc6421ba$var$arrowInAnimation = null;
const $56bb6720dc6421ba$export$554aaec702debd9a = ({ product: product, href: href, color: color, distanceMultiplier: distanceMultiplier = 2, useInViewOptions: useInViewOptions, onClick: onClick })=>{
    const { ref: scrollRef, inView: sectionIsVisible } = (0, $eDoPe.useInView)((0, $7Knp0._)({
        threshold: 0.5
    }, useInViewOptions));
    const translateX = `-${distanceMultiplier * 100}%`;
    const translateY = `-${distanceMultiplier * 50}%`;
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        className: (0, $esG4f.default)([
            "_1e0c1txw _1reoewfl _18m9ewfl"
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                className: (0, $esG4f.default)([
                    "_kqswh2mm"
                ]),
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)($56bb6720dc6421ba$export$8941bb92081bfaa5, {
                        color: color,
                        rotate: 26.4,
                        top: "-15%",
                        left: "-77px",
                        translateX: translateX,
                        translateY: translateY,
                        animate: sectionIsVisible
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)($56bb6720dc6421ba$export$8941bb92081bfaa5, {
                        color: color,
                        rotate: 2.4,
                        top: "40%",
                        left: "-79px",
                        translateX: translateX,
                        translateY: translateY,
                        animate: sectionIsVisible
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)($56bb6720dc6421ba$export$8941bb92081bfaa5, {
                        color: color,
                        rotate: -31.8,
                        top: "92%",
                        left: "-78px",
                        translateX: translateX,
                        translateY: translateY,
                        animate: sectionIsVisible
                    })
                ]
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("a", {
                ref: scrollRef,
                href: href,
                onClick: onClick,
                "aria-label": product,
                className: (0, $esG4f.default)([
                    "_1e0c116y _bfhku67f _2rkogktf _t9ec16ji _ca0qftgi _u5f3ftgi _n3tdftgi _19bvftgi _1l9u7vkz _w8l51gw8 _17521gw8 _rulp1yij _19ek1yij _1dbzuehs"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.Logo), {
                    brand: product,
                    type: "mark",
                    appearance: "brand"
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                className: (0, $esG4f.default)([
                    "_kqswh2mm"
                ]),
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)($56bb6720dc6421ba$export$8941bb92081bfaa5, {
                        color: color,
                        rotate: 137.7,
                        top: "-11%",
                        right: "-70px",
                        translateX: translateX,
                        translateY: translateY,
                        animate: sectionIsVisible
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)($56bb6720dc6421ba$export$8941bb92081bfaa5, {
                        color: color,
                        rotate: 169.6,
                        top: "37%",
                        right: "-84px",
                        translateX: translateX,
                        translateY: translateY,
                        animate: sectionIsVisible
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)($56bb6720dc6421ba$export$8941bb92081bfaa5, {
                        color: color,
                        rotate: -171.6,
                        top: "87%",
                        right: "-75px",
                        translateX: translateX,
                        translateY: translateY,
                        animate: sectionIsVisible
                    })
                ]
            })
        ]
    });
};

});



parcelRegister("bGVjH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9c1d4936a2dd2d5e$export$2e2bcd8739ae039; });
/* feel-supported-section.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $akGnX = parcelRequire("akGnX");

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $f6qj2 = parcelRequire("f6qj2");

var $dyZbY = parcelRequire("dyZbY");

var $ivwKs = parcelRequire("ivwKs");

var $kHg0E = parcelRequire("kHg0E");

var $3FBn4 = parcelRequire("3FBn4");
parcelRequire("2NBOx");
var $6FV3G = parcelRequire("6FV3G");
const $9c1d4936a2dd2d5e$var$feelSupportedSectionStyles = null;
const $9c1d4936a2dd2d5e$var$feelSupportedSectionHeaderStyles = null;
const $9c1d4936a2dd2d5e$var$infoCardContainerStyles = null;
const $9c1d4936a2dd2d5e$var$cardGroup = null;
const $9c1d4936a2dd2d5e$var$FeelSupportedSection = ()=>{
    const intl = (0, $f6qj2.default)();
    const infoCards1 = [
        {
            id: "atlassianCommunity",
            Icon: (0, $ivwKs.GroupsIcon),
            title: intl.formatMessage((0, $6FV3G.feelSupportedSectioni18n).atlassianCommunityInfoCardTitle),
            paragraph: intl.formatMessage((0, $6FV3G.feelSupportedSectioni18n).atlassianCommunityInfoCardParagraph),
            // callToActionText: intl.formatMessage(
            //     feelSupportedSectioni18n.atlassianCommunityInfoCardCallToActionText
            // ),
            callToActionUrl: "https://community.atlassian.com/t5/Confluence/ct-p/confluence",
            eventProps: {
                label: "atlassian-community",
                labelEnglish: "Atlassian Community"
            }
        },
        {
            id: "useCases",
            Icon: (0, $ivwKs.OfficeBuildingIcon),
            title: intl.formatMessage((0, $6FV3G.feelSupportedSectioni18n).useCasesInfoCardTitle),
            paragraph: intl.formatMessage((0, $6FV3G.feelSupportedSectioni18n).useCasesInfoCardParagraph),
            // callToActionText: intl.formatMessage(
            //     feelSupportedSectioni18n.useCasesInfoCardCallToActionText
            // ),
            callToActionUrl: (0, $3FBn4.useLocalizedHref)("/software/confluence/use-cases"),
            eventProps: {
                label: "use-cases",
                labelEnglish: "Use cases"
            }
        }
    ];
    const infoCards2 = [
        {
            id: "videoWalkthroughs",
            Icon: (0, $ivwKs.PlayIcon),
            title: intl.formatMessage((0, $6FV3G.feelSupportedSectioni18n).videoWalkthroughsInfoCardTitle),
            paragraph: intl.formatMessage((0, $6FV3G.feelSupportedSectioni18n).videoWalkthroughsInfoCardParagraph),
            // callToActionText: intl.formatMessage(
            //     feelSupportedSectioni18n.videoWalkthroughsInfoCardCallToActionText
            // ),
            callToActionUrl: (0, $3FBn4.useLocalizedHref)("/software/confluence/demo"),
            eventProps: {
                label: "video-walkthroughs",
                labelEnglish: "Video walkthroughs"
            }
        },
        {
            id: "productGuides",
            Icon: (0, $ivwKs.DocumentsIcon),
            title: intl.formatMessage((0, $6FV3G.feelSupportedSectioni18n).productGuidesInfoCardTitle),
            paragraph: intl.formatMessage((0, $6FV3G.feelSupportedSectioni18n).productGuidesInfoCardParagraph),
            // callToActionText: intl.formatMessage(
            //     feelSupportedSectioni18n.productGuidesInfoCardCallToActionText
            // ),
            callToActionUrl: (0, $3FBn4.useLocalizedHref)("/software/confluence/resources/guides"),
            eventProps: {
                label: "product-guides",
                labelEnglish: "Product guides"
            }
        }
    ];
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $dyZbY.default), {
        name: "confluence-pt-cfind-1234-feelSupportedSection",
        children: /*#__PURE__*/ (0, $loA2J.jsxs)("section", {
            className: (0, $esG4f.default)([
                "_1e0c1txw _2lx21bp4 _4cvr1h6o _1pfh1ylp _6rthzwfg _bozg1tcg _y4ti1tcg"
            ]),
            children: [
                /*#__PURE__*/ (0, $loA2J.jsx)("h2", {
                    className: (0, $esG4f.default)([
                        "_6rth1ex1 _gu181h6o"
                    ]),
                    children: intl.formatMessage((0, $6FV3G.feelSupportedSectioni18n).feelSupportSectionHeader)
                }),
                /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                    className: (0, $esG4f.default)([
                        "_1e0c1txw _19pkidpf _2hwx1wug _otyridpf _18u01wug _1n261g80 _zulp1tcg _p12f11vz _1bsb1osq"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                            className: (0, $esG4f.default)([
                                "_1e0c1txw _16jlkb7n _1o9zkb7n _i0dl1wug _zulp1tcg _1bah1h6o _1n261g80"
                            ]),
                            children: infoCards1.map((_param)=>/*#__PURE__*/ {
                                var { eventProps: eventProps, id: id } = _param, infoCardProps = (0, $akGnX._)(_param, [
                                    "eventProps",
                                    "id"
                                ]);
                                return (0, $loA2J.jsx)((0, $kHg0E.InfoCard), (0, $6iHNw._)((0, $7Knp0._)({}, infoCardProps), {
                                    dataEventProps: {
                                        "data-product-key": "confluence",
                                        "data-event": "clicked",
                                        "data-event-component": "card",
                                        "data-event-container": "additionalResourcesSection",
                                        "data-label": eventProps === null || eventProps === void 0 ? void 0 : eventProps.label,
                                        "data-label-english": eventProps === null || eventProps === void 0 ? void 0 : eventProps.labelEnglish
                                    }
                                }), id);
                            })
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                            className: (0, $esG4f.default)([
                                "_1e0c1txw _16jlkb7n _1o9zkb7n _i0dl1wug _zulp1tcg _1bah1h6o _1n261g80"
                            ]),
                            children: infoCards2.map((_param)=>/*#__PURE__*/ {
                                var { eventProps: eventProps, id: id } = _param, infoCardProps = (0, $akGnX._)(_param, [
                                    "eventProps",
                                    "id"
                                ]);
                                return (0, $loA2J.jsx)((0, $kHg0E.InfoCard), (0, $6iHNw._)((0, $7Knp0._)({}, infoCardProps), {
                                    dataEventProps: {
                                        "data-product-key": "confluence",
                                        "data-event": "clicked",
                                        "data-event-component": "card",
                                        "data-event-container": "additionalResourcesSection",
                                        "data-label": eventProps === null || eventProps === void 0 ? void 0 : eventProps.label,
                                        "data-label-english": eventProps === null || eventProps === void 0 ? void 0 : eventProps.labelEnglish
                                    }
                                }), id);
                            })
                        })
                    ]
                })
            ]
        })
    });
};
$9c1d4936a2dd2d5e$var$FeelSupportedSection.displayName = "FeelSupportedSection";
var $9c1d4936a2dd2d5e$export$2e2bcd8739ae039 = $9c1d4936a2dd2d5e$var$FeelSupportedSection;

});
parcelRegister("kHg0E", function(module, exports) {

$parcel$export(module.exports, "InfoCard", function () { return $fdbc4f5136085f61$export$2a4a2d730793fc2a; });
/* info-card.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
const $fdbc4f5136085f61$var$infoCardContainerStyles = null;
const $fdbc4f5136085f61$var$titleStyles = null;
const $fdbc4f5136085f61$var$paragraphStyles = null;
const $fdbc4f5136085f61$var$iconContainerStyles = null;
const $fdbc4f5136085f61$export$2a4a2d730793fc2a = ({ Icon: Icon, title: title, paragraph: paragraph, callToActionUrl: callToActionUrl, iconSize: iconSize = "48", dataEventProps: dataEventProps })=>{
    const isExternalHref = callToActionUrl.startsWith("https://");
    return /*#__PURE__*/ (0, $loA2J.jsx)("a", (0, $6iHNw._)((0, $7Knp0._)({
        href: callToActionUrl,
        target: isExternalHref ? "_blank" : undefined,
        rel: isExternalHref ? "noreferrer noopener" : undefined
    }, dataEventProps), {
        children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
            className: (0, $esG4f.default)([
                "_1e0c1txw _1bsb1178 _1tke4cy5 _1yt45gjp _2lx21bp4 _1bah1h6o _4cvr1y6m _zulp19bv _1o9zidpf _2rkou2gc _bfhku67f _19it14it _v564jfwv _1dbzv75q"
            ]),
            children: [
                /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                    className: (0, $esG4f.default)([
                        "_1pfhgktf"
                    ]),
                    children: /*#__PURE__*/ (0, $loA2J.jsx)(Icon, {
                        size: iconSize
                    })
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)("h3", {
                    className: (0, $esG4f.default)([
                        "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _vwz41ul9",
                        "h4"
                    ]),
                    children: title
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                    className: (0, $esG4f.default)([
                        "_1tket9kd _19pkidpf _2hwxidpf _otyridpf _18u0idpf _6rth1wug _vwz41tcg"
                    ]),
                    children: paragraph
                })
            ]
        })
    }));
};

});

parcelRegister("2NBOx", function(module, exports) {
$parcel$export(module.exports, "feelSupportedSectioni18n", function () { return (parcelRequire("6FV3G")).feelSupportedSectioni18n; });
$parcel$export(module.exports, "whyConfluenceSectioni18n", function () { return (parcelRequire("4FVkO")).whyConfluenceSectioni18n; });
parcelRequire("6FV3G");
parcelRequire("4FVkO");

});
parcelRegister("6FV3G", function(module, exports) {

$parcel$export(module.exports, "feelSupportedSectioni18n", function () { return $3bd5eeefed7105a3$export$2388077e1c060dc; });

var $6x1qA = parcelRequire("6x1qA");
const $3bd5eeefed7105a3$export$2388077e1c060dc = (0, $6x1qA.defineMessages)({
    feelSupportSectionHeader: {
        id: "ConfluenceSoftwarePage.v4.FeelSupportedSection.Header",
        defaultMessage: "Feel supported every step of the way"
    },
    atlassianCommunityInfoCardTitle: {
        id: "ConfluenceSoftwarePage.v4.FeelSupportedSection.InfoCard.AtlassianCommunity.Title",
        defaultMessage: "Atlassian Community"
    },
    atlassianCommunityInfoCardParagraph: {
        id: "ConfluenceSoftwarePage.v4.FeelSupportedSection.InfoCard.AtlassianCommunity.Paragraph",
        defaultMessage: "Your questions, answered by our community of experts"
    },
    atlassianCommunityInfoCardCallToActionText: {
        id: "ConfluenceSoftwarePage.v4.FeelSupportedSection.InfoCard.AtlassianCommunity.CallToAction.Text",
        defaultMessage: "Join now"
    },
    useCasesInfoCardTitle: {
        id: "ConfluenceSoftwarePage.v4.FeelSupportedSection.InfoCard.UseCases.Title",
        defaultMessage: "Use cases"
    },
    useCasesInfoCardParagraph: {
        id: "ConfluenceSoftwarePage.v4.FeelSupportedSection.InfoCard.UseCases.Paragraph",
        defaultMessage: "How different industries & teams use Confluence"
    },
    useCasesInfoCardCallToActionText: {
        id: "ConfluenceSoftwarePage.v4.FeelSupportedSection.InfoCard.UseCases.CallToAction.Text",
        defaultMessage: "Learn more"
    },
    videoWalkthroughsInfoCardTitle: {
        id: "ConfluenceSoftwarePage.v4.FeelSupportedSection.InfoCard.VideoWalkthroughs.Title",
        defaultMessage: "Video walkthroughs"
    },
    videoWalkthroughsInfoCardParagraph: {
        id: "ConfluenceSoftwarePage.v4.FeelSupportedSection.InfoCard.VideoWalkthroughs.Paragraph",
        defaultMessage: "Visual explanations for features & setup steps"
    },
    videoWalkthroughsInfoCardCallToActionText: {
        id: "ConfluenceSoftwarePage.v4.FeelSupportedSection.InfoCard.VideoWalkthroughs.CallToAction.Text",
        defaultMessage: "Watch now"
    },
    productGuidesInfoCardTitle: {
        id: "ConfluenceSoftwarePage.v4.FeelSupportedSection.InfoCard.ProductGuides.Title",
        defaultMessage: "User guides"
    },
    productGuidesInfoCardParagraph: {
        id: "ConfluenceSoftwarePage.v4.FeelSupportedSection.InfoCard.ProductGuides.Paragraph",
        defaultMessage: "In-depth guides to help build your Confluence expertise"
    },
    productGuidesInfoCardCallToActionText: {
        id: "ConfluenceSoftwarePage.v4.FeelSupportedSection.InfoCard.ProductGuides.CallToAction.Text",
        defaultMessage: "Read more"
    }
});

});

parcelRegister("4FVkO", function(module, exports) {

$parcel$export(module.exports, "whyConfluenceSectioni18n", function () { return $c5acb551b5b1d3bc$export$ab4765e2b00a177e; });

var $6x1qA = parcelRequire("6x1qA");
const $c5acb551b5b1d3bc$export$ab4765e2b00a177e = (0, $6x1qA.defineMessages)({
    whyConfluenceSectionHeader: {
        id: "ConfluenceSoftwarePage.v4.WhyConfluenceSection.Header",
        defaultMessage: "Why Confluence?"
    },
    versatileContentCreationInfoBoxTitle: {
        id: "ConfluenceSoftwarePage.v4.WhyConfluenceSection.InfoBox.VersatileContentCreation.Title",
        defaultMessage: "Versatile content creation"
    },
    versatileContentCreationInfoBoxParagraph: {
        id: "ConfluenceSoftwarePage.v4.WhyConfluenceSection.InfoBox.VersatileContentCreation.Paragraph",
        defaultMessage: "Bring your ideas to life with a rich palette of content: Whiteboards, Databases, and videos within every Confluence Page."
    },
    organizationThatScalesInfoBoxTitle: {
        id: "ConfluenceSoftwarePage.v4.WhyConfluenceSection.InfoBox.OrganizationThatScales.Title",
        defaultMessage: "Organization that scales"
    },
    organizationThatScalesInfoBoxParagraph: {
        id: "ConfluenceSoftwarePage.v4.WhyConfluenceSection.InfoBox.OrganizationThatScales.Paragraph",
        defaultMessage: "You\u2019ll never outgrow Confluence. Project resources and company knowledge stay centralized and discoverable."
    },
    powerfulIntegrationsInfoBoxTitle: {
        id: "ConfluenceSoftwarePage.v4.WhyConfluenceSection.InfoBox.PowerfulIntegrations.Title",
        defaultMessage: "Powerful integrations"
    },
    powerfulIntegrationsInfoBoxParagraph: {
        id: "ConfluenceSoftwarePage.v4.WhyConfluenceSection.InfoBox.PowerfulIntegrations.Paragraph",
        defaultMessage: "Connect Confluence to thousands of your favorite tools to access data and manage workflows across apps."
    },
    dataProtectionInfoBoxTitle: {
        id: "ConfluenceSoftwarePage.v4.WhyConfluenceSection.InfoBox.DataProtection.Title",
        defaultMessage: "Data protection"
    },
    dataProtectionInfoBoxParagraph: {
        id: "ConfluenceSoftwarePage.v4.WhyConfluenceSection.InfoBox.DataProtection.Paragraph",
        defaultMessage: "User-level permissions keep your information private. Company data stays secure and always remains in your control."
    }
});

});



parcelRegister("12KoV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9a4c42a10390b79f$export$2e2bcd8739ae039; });
/* hero-text-section.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $dFnC9 = parcelRequire("dFnC9");
var $f6qj2 = parcelRequire("f6qj2");

var $dyZbY = parcelRequire("dyZbY");

var $i8kxh = parcelRequire("i8kxh");

var $91nJf = parcelRequire("91nJf");

var $bGE1b = parcelRequire("bGE1b");

var $3LLDq = parcelRequire("3LLDq");

var $axg8K = parcelRequire("axg8K");

var $f0Hih = parcelRequire("f0Hih");

var $bhreu = parcelRequire("bhreu");

var $5ohHq = parcelRequire("5ohHq");

var $3FBn4 = parcelRequire("3FBn4");

var $4XrxY = parcelRequire("4XrxY");

var $9iWJ8 = parcelRequire("9iWJ8");

var $1MbAx = parcelRequire("1MbAx");

var $jMPt0 = parcelRequire("jMPt0");
const $9a4c42a10390b79f$var$sectionStyle = null;
const $9a4c42a10390b79f$var$relative = null;
const $9a4c42a10390b79f$var$wrapper = null;
const $9a4c42a10390b79f$var$embeddedSignupStyle = null;
const $9a4c42a10390b79f$var$submitWrapperStyle = null;
const $9a4c42a10390b79f$var$socialWrapperStyle = null;
const $9a4c42a10390b79f$var$cfind4334SocialWrapperStyle = null;
const $9a4c42a10390b79f$export$86cbf5054d71d20c = ({ lineBreak: lineBreak = false })=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
        id: "ConfluenceSoftwarePage.v4.heroHeader",
        defaultMessage: "Goodbye silos, <bold-text>hello</bold-text> <underline-comp>teamwork</underline-comp>",
        values: {
            "bold-text": (node)=>/*#__PURE__*/ (0, $loA2J.jsxs)((0, $loA2J.Fragment), {
                    children: [
                        lineBreak && /*#__PURE__*/ (0, $loA2J.jsx)("br", {}),
                        /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                            className: "superhero",
                            children: node
                        })
                    ]
                }),
            "underline-comp": (node)=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $bGE1b.Adg4TextUnderline), {
                    underlineInset: "-28%",
                    underline: /*#__PURE__*/ (0, $loA2J.jsx)((0, $bhreu.Picture), {
                        image: {
                            src: "https://dam-cdn.atl.orangelogic.com/AssetLink/i01olj0l1c7t5w32dncm1wn5853ibm16.svg",
                            alt: "hero underline"
                        }
                    }),
                    children: node
                })
        }
    });
};
const $9a4c42a10390b79f$var$HeroTextSection = ({ userProfile: userProfile })=>{
    const intl = (0, $f6qj2.default)();
    const ctaText = intl.formatMessage({
        id: "ConfluenceSoftwarePage.v4.heroCTA",
        defaultMessage: "Get Confluence free"
    });
    const signupLink = (0, $3FBn4.useLocalizedHref)("/software/confluence/free");
    const { openCrossFlow: openCrossFlow } = (0, $3LLDq.useCrossFlowFrontendTouchpoint)({
        productKey: (0, $i8kxh.ProductKeys).CONFLUENCE,
        edition: (0, $i8kxh.Editions).FREE,
        redirectUrl: signupLink
    });
    const embeddedSignup = !userProfile;
    (0, $1MbAx.useFeatureExposed)("cfind-2432_embedded_sign-up_confluence_unpaid_pt", "Test", {
        conditions: [
            embeddedSignup
        ]
    });
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $dyZbY.default), {
        name: "confluence-pt-cfind-1234-heroTextSection",
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.TypographyStyles), {
            children: /*#__PURE__*/ (0, $loA2J.jsx)("section", {
                className: (0, $esG4f.default)([
                    "_85i5pxbi _1reo15vq _18m915vq"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                    className: (0, $esG4f.default)([
                        "_kqswh2mm _ca0qidpf _u5f31tcg _n3tdidpf _19bv1tcg _1kt9b3bt _1cs8stnw _z5wtidpf _iajmidpf _1y8l1git _1mp4auwl _kfgt1osq _1s6k1ybm _tgsmz517 _1g0v1mrw"
                    ]),
                    style: {
                        "--_1hkddbi": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.extended.blue100"))
                    },
                    children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                        className: (0, $esG4f.default)([
                            "_p12f6nhw _1e0c1txw _1bah1h6o _4cvr1h6o _zulp1wto _19pk1wug _2hwx1wug _otyr1wug _18u01wug _1gde1bp4 _8164idpf",
                            embeddedSignup && "_1bah1yb4"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $loA2J.jsx)((0, $jMPt0.default), {
                                header: /*#__PURE__*/ (0, $loA2J.jsx)($9a4c42a10390b79f$export$86cbf5054d71d20c, {
                                    lineBreak: embeddedSignup
                                }),
                                subHeader: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                                    id: "ConfluenceSoftwarePage.v4.heroSubHeading",
                                    defaultMessage: "Create, share, and harness knowledge across teams"
                                }),
                                leftAligned: embeddedSignup,
                                cta: !embeddedSignup && /*#__PURE__*/ (0, $loA2J.jsx)((0, $f0Hih.default), {
                                    intentType: "button",
                                    containerId: "heroSection",
                                    productKey: "confluence",
                                    edition: "free",
                                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $91nJf.Adg4Button), {
                                        variant: "primary",
                                        size: "large",
                                        color: "blue",
                                        onClick: openCrossFlow,
                                        href: signupLink,
                                        dataEventProps: {
                                            "data-product-key": "confluence",
                                            "data-event": "clicked",
                                            "data-event-component": "linkButton",
                                            "data-event-container": "heroSection",
                                            "data-label": "hero-get-confluence-free",
                                            "data-label-english": "Get Confluence free",
                                            "data-track-event": "confluence-pt.get-confluence-free.cta"
                                        },
                                        children: ctaText
                                    }, "confluence")
                                })
                            }),
                            embeddedSignup && /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                className: (0, $esG4f.default)([
                                    "_1bsb1qbf _ca0q1wto _u5f3idpf _n3td1wto _19bvidpf _1u2qidpf _1vdkidpf"
                                ]),
                                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $axg8K.default), {
                                    Input: /*#__PURE__*/ (0, $loA2J.jsx)((0, $axg8K.Input), {
                                        helpText: null
                                    }),
                                    Submit: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                        className: (0, $esG4f.default)([
                                            "_1o7p1j6v _1wtni2wt _d4lf1ylp"
                                        ]),
                                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $axg8K.Submit), {})
                                    }),
                                    Social: /*#__PURE__*/ (0, $loA2J.jsx)((0, $9iWJ8.ExperimentView), {
                                        experiment: (0, $9iWJ8.experiments).cfind4327ConfEliminateMicrosoftSignup,
                                        render: (value)=>{
                                            if (value) return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                                className: (0, $esG4f.default)([
                                                    "_jk7416hb _1b94glyw"
                                                ]),
                                                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $axg8K.Social), {
                                                    providers: {
                                                        google: "Google",
                                                        apple: "Apple",
                                                        slack: "Slack"
                                                    }
                                                })
                                            });
                                            return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                                className: (0, $esG4f.default)([
                                                    "_jk741ezz _1b94glyw"
                                                ]),
                                                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $axg8K.Social), {})
                                            });
                                        }
                                    }),
                                    Login: null
                                })
                            })
                        ]
                    })
                })
            })
        })
    });
};
$9a4c42a10390b79f$var$HeroTextSection.displayName = "HeroTextSection";
var $9a4c42a10390b79f$export$2e2bcd8739ae039 = $9a4c42a10390b79f$var$HeroTextSection;

});

parcelRegister("dIO0r", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4957f9655817a338$export$2e2bcd8739ae039; });

var $loA2J = parcelRequire("loA2J");

var $f6qj2 = parcelRequire("f6qj2");

var $dyZbY = parcelRequire("dyZbY");

var $3FBn4 = parcelRequire("3FBn4");

var $3MXTK = parcelRequire("3MXTK");

var $ccYBS = parcelRequire("ccYBS");
const $4957f9655817a338$var$IntegrationsSection = ()=>{
    const intl = (0, $f6qj2.default)();
    const iconData = [
        {
            url: "https://wac-cdn.atlassian.com/misc-assets/svgs/jira.svg",
            altText: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.integrations.jira-logo-alt",
                defaultMessage: "The Jira logo which resembles three arrowheads pointing up and to the right."
            }),
            href: (0, $3FBn4.useLocalizedHref)("/software/confluence/jira-integration")
        },
        {
            url: "https://wac-cdn.atlassian.com/misc-assets/svgs/loom_beam_color.svg",
            altText: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.integrations.loom-logo-alt",
                defaultMessage: "Loom logo"
            }),
            href: "https://marketplace.atlassian.com/apps/1225947/loom-for-confluence"
        },
        {
            url: "https://wac-cdn.atlassian.com/misc-assets/svgs/trello-icon-logo.svg",
            altText: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.integrations.trello-logo-alt",
                defaultMessage: "Trello logo which resembles a trello board with two columns."
            }),
            href: (0, $3FBn4.useLocalizedHrefTrello)("/")
        },
        {
            url: "https://wac-cdn.atlassian.com/misc-assets/svgs/microsoft-teams.svg",
            altText: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.integrations.microsoft-teams-logo-alt",
                defaultMessage: "Microsoft Teams logo"
            }),
            href: (0, $3FBn4.useLocalizedHref)("/software/confluence/microsoft-teams-integration")
        },
        {
            url: "https://wac-cdn.atlassian.com/misc-assets/svgs/figma.svg",
            altText: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.integrations.figma-logo-alt",
                defaultMessage: "Figma logo"
            }),
            href: "https://marketplace.atlassian.com/apps/1221692/figma-for-confluence"
        },
        {
            url: "https://wac-cdn.atlassian.com/misc-assets/svgs/slack-icon-logo.svg",
            altText: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.integrations.slack-logo-alt",
                defaultMessage: "Slack logo"
            }),
            href: "https://marketplace.atlassian.com/apps/1219518/confluence-cloud-for-slack-official"
        },
        {
            url: "https://wac-cdn.atlassian.com/misc-assets/svgs/google-drive-logo.svg",
            altText: intl.formatMessage({
                id: "ConfluenceSoftwarePageTemplate.integrations.google-drive-logo-alt",
                defaultMessage: "Google Drive logo"
            }),
            href: "https://marketplace.atlassian.com/apps/1216978/google-drive-and-docs-for-confluence"
        }
    ];
    const headingText = intl.formatMessage({
        id: "ConfluenceSoftwarePage.v4.integrationsSection.header",
        defaultMessage: "Integrate with your faves"
    });
    const bodyText = intl.formatMessage({
        id: "ConfluenceSoftwarePage.v4.integrationsSection.body",
        defaultMessage: "All the tools you know and love integrate smoothly with Confluence"
    });
    const ctaText = intl.formatMessage({
        id: "ConfluenceSoftwarePage.v4.integrationsSection.cta",
        defaultMessage: "Go to Marketplace"
    });
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $dyZbY.default), {
        name: "confluence-pt-cfind-1234-integrationsSection",
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $ccYBS.ScrollTracking), {
            section: "IntegrationsSection",
            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $3MXTK.Adg4OffsetIconCollection), {
                iconData: iconData,
                headingText: headingText,
                bodyText: bodyText,
                ctaText: ctaText,
                productKey: "confluence",
                ctaLink: "https://marketplace.atlassian.com/addons/app/confluence"
            })
        })
    });
};
$4957f9655817a338$var$IntegrationsSection.displayName = "IntegrationsSection";
var $4957f9655817a338$export$2e2bcd8739ae039 = $4957f9655817a338$var$IntegrationsSection;

});
parcelRegister("3MXTK", function(module, exports) {

$parcel$export(module.exports, "Adg4OffsetIconCollection", function () { return $64cbc5fbef582537$export$df552133577e6dc7; });
/* offset-icon-collection.tsx generated by @compiled/babel-plugin v0.28.8 */ // @ts-ignore

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $eDoPe = parcelRequire("eDoPe");

var $91nJf = parcelRequire("91nJf");

var $5ohHq = parcelRequire("5ohHq");
const $64cbc5fbef582537$var$sectionContainer = null;
const $64cbc5fbef582537$var$contentContainer = null;
const $64cbc5fbef582537$var$textContainerStyles = null;
const $64cbc5fbef582537$var$headingTextStyles = null;
const $64cbc5fbef582537$var$bodyTextStyles = null;
const $64cbc5fbef582537$var$iconContainerStyles = null;
const $64cbc5fbef582537$var$iconStyles = null;
const $64cbc5fbef582537$var$linkStyles = null;
const $64cbc5fbef582537$var$animationStyle = null;
const $64cbc5fbef582537$export$df552133577e6dc7 = ({ iconData: iconData, textPosition: textPosition = "right", headingText: headingText, bodyText: bodyText, ctaText: ctaText, ctaLink: ctaLink, productKey: productKey, ctaOnClickFunc: ctaOnClickFunc })=>{
    const { ref: scrollRef, inView: sectionIsVisible } = (0, $eDoPe.useInView)();
    const isExternalHref = ctaLink.startsWith("https://");
    const textSection = /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        className: (0, $esG4f.default)([
            "_1e0c1txw _2lx21bp4 _4cvr1y6m _1bah1h6o _1gde1bp4 _ag851h6o _xsmr1h6o"
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("h3", {
                className: (0, $esG4f.default)([
                    "_1mouidpf"
                ]),
                children: headingText
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                className: (0, $esG4f.default)([
                    "_1mouidpf _1pfh1kwk _6rth1k8s _p12f1yxl _8fz6jbd8"
                ]),
                children: bodyText
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $91nJf.Adg4Button), {
                variant: "secondary",
                size: "large",
                color: "black",
                href: ctaLink,
                target: isExternalHref ? "_blank" : undefined,
                rel: isExternalHref ? "noreferrer noopener" : undefined,
                onClick: ctaOnClickFunc,
                dataEventProps: productKey ? {
                    "data-product-key": productKey,
                    "data-event": "clicked",
                    "data-event-component": "linkButton",
                    "data-event-container": "integrationsSection",
                    "data-label": "integrations-cta",
                    "data-track-event": "integrations.cta"
                } : undefined,
                children: ctaText
            })
        ]
    });
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: (0, $esG4f.default)([
            "_1bsb1osq _1e0c1txw _1bah1h6o _4cvr1h6o _2lx21bp4"
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
            className: (0, $esG4f.default)([
                "_1e0c1txw _2lx2vrvc _p12f17gh _1mouviql _zulp1et3 _1p5sckbl _1gzv14no _suga1txw _1gde1bp4 _ag851h6o _81641tcg"
            ]),
            children: [
                textPosition !== "right" && textSection,
                /*#__PURE__*/ (0, $loA2J.jsx)("ul", {
                    ref: scrollRef,
                    className: (0, $esG4f.default)([
                        "_1e0c1txw _1n261g80 _i0dl1osq _zulp6veu _1bah1h6o _ae4v1h6o _p12f1vci _1o9zidpf _qtt8glyw _18zridpf _1p5s1bkc _ceho1byl _2osn7vkz _8fz6jbd8"
                    ]),
                    children: iconData.map((icon, index)=>/*#__PURE__*/ (0, $loA2J.jsx)("li", {
                            children: icon.href ? /*#__PURE__*/ (0, $loA2J.jsx)("a", {
                                href: icon.href,
                                "data-product-key": productKey,
                                "data-event-container": "integrationsSection",
                                "data-event-component": "linkButton",
                                "data-label": icon.altText,
                                "data-event": "clicked",
                                "data-track-event": "integrations.icon",
                                className: (0, $esG4f.default)([
                                    "_2rkod4y9 _1e0c1txw _4cvr1h6o _1bah1h6o _tip8kb7n _5sagw1p3 _11q7cd5j _1bsb18ly _4t3i18ly _rtys1ssb _19l31ssb _mezj1wug _bna71wug _1leho7ao _1hr216xz _159516xz _1l9uo7ao _1s4pvbgk _1knevbgk",
                                    "_80omtlke _16qs1yxe _1dbzjojz",
                                    sectionIsVisible && "_j7hq1nm9"
                                ]),
                                style: {
                                    animationDelay: `${0.5 + 0.25 * index}s`,
                                    "--_7zbnls": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light0"))
                                },
                                children: /*#__PURE__*/ (0, $loA2J.jsx)("img", {
                                    src: icon.url,
                                    alt: icon.altText
                                })
                            }) : /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                className: (0, $esG4f.default)([
                                    "_2rkod4y9 _1e0c1txw _4cvr1h6o _1bah1h6o _tip8kb7n _5sagw1p3 _11q7cd5j _1bsb18ly _4t3i18ly _rtys1ssb _19l31ssb _mezj1wug _bna71wug _1leho7ao _1hr216xz _159516xz _1l9uo7ao _1s4pvbgk _1knevbgk",
                                    sectionIsVisible && "_j7hq1nm9"
                                ]),
                                style: {
                                    animationDelay: `${0.5 + 0.25 * index}s`,
                                    "--_7zbnls": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light0"))
                                },
                                children: /*#__PURE__*/ (0, $loA2J.jsx)("img", {
                                    src: icon.url,
                                    alt: icon.altText
                                })
                            })
                        }, index))
                }),
                textPosition === "right" && textSection
            ]
        })
    });
};

});


parcelRegister("3Z0sj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $feea6953423682aa$export$2e2bcd8739ae039; });
/* scroller-section.tsx generated by @compiled/babel-plugin v0.28.8 */ // @ts-ignore

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $eDoPe = parcelRequire("eDoPe");

var $dFnC9 = parcelRequire("dFnC9");
var $f6qj2 = parcelRequire("f6qj2");

var $dyZbY = parcelRequire("dyZbY");

var $i8kxh = parcelRequire("i8kxh");

var $91nJf = parcelRequire("91nJf");
parcelRequire("6VNwL");
var $4RMnv = parcelRequire("4RMnv");

var $3LLDq = parcelRequire("3LLDq");

var $f0Hih = parcelRequire("f0Hih");

var $1UUq1 = parcelRequire("1UUq1");

var $5ohHq = parcelRequire("5ohHq");

var $3FBn4 = parcelRequire("3FBn4");

var $ElG1F = parcelRequire("ElG1F");

var $ccYBS = parcelRequire("ccYBS");
const $feea6953423682aa$var$contentStyles = null;
const $feea6953423682aa$var$headingStyles = null;
const $feea6953423682aa$var$textStyles = null;
const $feea6953423682aa$var$scrollerHeading = null;
const $feea6953423682aa$var$buttonContainer = null;
const $feea6953423682aa$var$arrowStyles = null;
const $feea6953423682aa$var$sectionStyle = null;
const $feea6953423682aa$var$arrowInAnimation = null;
const $feea6953423682aa$export$272f9c9325d00e8b = (props)=>{
    const transformStyles = null;
    var _props_rotate;
    return /*#__PURE__*/ (0, $loA2J.jsx)("svg", {
        width: "72",
        height: "25",
        viewBox: "0 0 72 25",
        xmlns: "http://www.w3.org/2000/svg",
        className: (0, $esG4f.default)([
            "_kqswstnw _5sag9cwz _ju251yx9 _tip8kb7n _1o51eoah",
            props.animate && "_j7hqxb4k"
        ]),
        style: {
            insetInlineStart: props.left,
            insetInlineEnd: props.right,
            insetBlockStart: props.top,
            insetBlockEnd: props.bottom,
            transform: `rotate(${props.rotate ? props.rotate : "0"}deg)`,
            color: props.color ? props.color : "currentColor",
            visibility: props.animate ? "visible" : "hidden",
            "--_l8fg41": (0, $43MIc.default)((_props_rotate = props.rotate) !== null && _props_rotate !== void 0 ? _props_rotate : 0, "deg")
        },
        children: /*#__PURE__*/ (0, $loA2J.jsx)("path", {
            d: "M59.9377 15.3992C59.0173 14.9197 58.1224 14.8026 57.2375 14.6506C56.2764 14.4847 55.3298 14.5122 54.3661 14.6939C53.5179 14.8575 52.6572 14.756 51.8548 14.5047C50.3545 14.0308 48.8161 13.9548 47.2581 13.9487C46.2852 13.9435 45.2992 13.8949 44.3421 13.7474C43.6788 13.6425 43.0503 13.3313 42.3766 13.1053C41.985 13.7302 41.3847 13.7038 40.7654 13.4715C39.4868 12.9907 38.1709 12.9018 36.8181 12.9291C36.0821 12.9425 35.3546 12.7709 34.7504 12.2942C34.6729 12.2382 34.5745 12.21 34.4827 12.1765C33.8726 12.7787 33.1602 12.7406 32.4202 12.5737C31.2308 12.3121 30.0329 12.0735 28.8435 11.8119C28.0392 11.6324 27.2369 11.435 26.434 11.2435C25.6375 11.0468 24.8746 10.7635 24.004 10.9669C22.9249 11.2205 21.8431 10.958 20.7692 10.7864C19.5431 10.5869 18.3301 10.2689 17.1034 10.1833C15.0061 10.0312 12.9448 9.66091 10.8685 9.37304C9.87464 9.2337 8.87682 9.12994 7.89344 8.94972C6.89235 8.76766 5.89651 8.53817 4.91509 8.28619C3.86938 8.02152 2.82958 7.7035 1.79371 7.40388C1.12194 7.21408 0.740116 6.67063 0.443572 6.11206C0.359595 5.95341 0.591152 5.53371 0.780077 5.33746C1.3744 4.71561 2.13013 4.41639 2.99148 4.35003C4.92541 4.19732 6.85018 4.28953 8.7651 4.47067C10.4852 4.63154 12.1902 4.92878 13.8886 5.23134C15.8515 5.57338 17.8274 5.79684 19.8165 5.95571C21.368 6.07507 22.9135 6.30175 24.4618 6.45076C25.9089 6.59525 27.3614 6.69231 28.8151 6.83149C30.4224 6.98663 32.0303 7.13584 33.6388 7.3331C35.9198 7.60628 38.1897 7.92627 40.47 8.20538C42.0904 8.40386 43.7114 8.59642 45.3646 8.49847C46.3027 8.4401 47.2618 8.62379 48.1927 8.79256C49.5336 9.03394 50.885 9.07253 52.239 9.14136C53.8902 9.22311 55.5421 9.29894 57.1985 9.38723C57.6735 9.41263 58.1432 9.48547 58.6182 9.51087C58.7481 9.52438 58.8865 9.46081 59.0203 9.43874C58.9685 9.31341 58.9514 9.14372 58.8583 9.06807C58.3052 8.61476 57.7305 8.19518 57.1775 7.74187C55.7106 6.53386 54.2437 5.32585 52.784 4.1066C52.2211 3.63427 51.8989 2.98308 51.5571 2.34784C51.3492 1.9604 51.5341 1.63781 51.7218 1.34547C51.9021 1.06438 52.0235 0.669208 52.4453 0.635111C52.7346 0.611222 53.0239 0.587334 53.3159 0.593703C54.7643 0.618392 56.0541 1.16031 57.3235 1.77807C58.2302 2.22017 59.1204 2.70255 60.0415 3.12217C60.4279 3.30028 60.6627 3.55259 60.8241 3.92919C60.9383 4.19293 61.0275 4.52005 61.4388 4.203C61.6212 4.06605 61.8429 4.11309 62.0102 4.32839C62.2563 4.64183 62.5469 4.92992 62.7922 5.24929C62.9589 5.47051 63.1498 5.52635 63.422 5.54866C64.448 5.61337 65.2517 6.12273 65.8284 6.95631C66.199 7.4926 66.6963 7.85616 67.2599 8.10666C67.9146 8.39663 68.5004 8.76939 68.9623 9.29118C69.8119 10.2491 70.6155 11.2442 71.4126 12.2446C71.7531 12.6758 71.6567 13.4934 71.2651 13.9024C70.5625 14.639 69.8337 15.3428 69.1476 16.093C68.7802 16.4986 68.4883 16.978 68.1472 17.4163C68.0081 17.5937 67.8625 17.8305 67.6703 17.8944C66.9192 18.1522 66.4311 18.7311 65.8676 19.2362C65.6354 19.4459 65.3887 19.6782 65.1073 19.7928C64.1935 20.1716 63.2705 20.5253 62.3343 20.8358C62.0614 20.9274 61.7282 20.8087 61.4231 20.813C61.2854 20.8167 61.0794 20.8432 61.0217 20.9332C60.5146 21.738 59.7602 22.1333 58.8588 22.1835C57.4825 22.2623 56.1856 22.7031 54.8565 23.0027C53.3253 23.3472 51.7949 23.6858 50.267 24.0547C49.0888 24.34 47.9008 24.4443 46.6976 24.4151C46.1853 24.4038 45.8133 24.1493 45.6316 23.7406C45.2412 22.8424 45.1435 22.8622 45.7706 22.0519C45.8893 21.8963 46.0244 21.7544 46.1209 21.5846C46.4935 20.9157 47.1521 20.7922 47.8029 20.5781C48.9181 20.2143 50.011 19.7822 51.0986 19.3436C52.5241 18.7662 53.93 18.1508 55.345 17.5603C56.1092 17.2379 56.8866 16.959 57.6358 16.6111C58.3849 16.2632 59.1046 15.8583 59.9219 15.4335L59.9377 15.3992Z",
            fill: "currentColor"
        })
    });
};
const $feea6953423682aa$var$AnimatedArrowButton = ({ href: href, text: text, onClick: onClick, label: label, labelEnglish: labelEnglish })=>{
    const { ref: scrollRef, inView: sectionIsVisible } = (0, $eDoPe.useInView)({
        threshold: 1
    });
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        ref: scrollRef,
        className: (0, $esG4f.default)([
            "_kqswh2mm _1e0c1o8l"
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $91nJf.Adg4Button), {
                href: href,
                color: "blue",
                size: "large",
                onClick: onClick,
                dataEventProps: {
                    "data-product-key": "confluence",
                    "data-event": "clicked",
                    "data-event-component": "linkButton",
                    "data-event-container": "scrollPinnedSection",
                    "data-label": label,
                    "data-label-english": labelEnglish
                },
                children: text
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)($feea6953423682aa$export$272f9c9325d00e8b, {
                rotate: 180,
                right: -88,
                top: "25%",
                animate: sectionIsVisible
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)($feea6953423682aa$export$272f9c9325d00e8b, {
                rotate: -140,
                right: -61,
                bottom: -49,
                animate: sectionIsVisible
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)($feea6953423682aa$export$272f9c9325d00e8b, {
                rotate: -121,
                right: 0,
                bottom: -62,
                animate: sectionIsVisible
            })
        ]
    });
};
const $feea6953423682aa$var$ScrollerContent = ({ item: item })=>{
    const { ref: ref } = (0, $ccYBS.useScrollTracking)(`ScrollerSectionItem-${item.id}`);
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        ref: ref,
        className: (0, $esG4f.default)([
            "_xsmr1h6o"
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("h3", {
                className: (0, $esG4f.default)([
                    "_19pkidpf _2hwxidpf _otyridpf _18u0idpf"
                ]),
                children: item.title
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                className: (0, $esG4f.default)([
                    "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _1q517vkz _85i51tcg"
                ]),
                children: item.description
            }),
            item.link && item.link.type === "link" && /*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.Link), {
                text: item.link.text,
                ariaLabel: item.link.ariaLabelText,
                href: item.link.href,
                onClick: item.link.onClick,
                dataEventProps: {
                    "data-product-key": "confluence",
                    "data-event": "clicked",
                    "data-event-component": "linkButton",
                    "data-event-container": "scrollPinnedSection",
                    "data-label": item.link.label,
                    "data-label-english": item.link.labelEnglish
                }
            }),
            item.link && item.link.type === "button" && /*#__PURE__*/ (0, $loA2J.jsx)((0, $f0Hih.default), {
                intentType: "button",
                containerId: "scrollPinnedSection",
                productKey: "confluence",
                edition: "free",
                children: /*#__PURE__*/ (0, $loA2J.jsx)($feea6953423682aa$var$AnimatedArrowButton, {
                    href: item.link.href,
                    text: item.link.text,
                    onClick: item.link.onClick,
                    label: item.link.label,
                    labelEnglish: item.link.labelEnglish
                })
            })
        ]
    });
};
const $feea6953423682aa$var$ScrollerSection = ()=>{
    const intl = (0, $f6qj2.default)();
    const featuresLink = (0, $3FBn4.useLocalizedHref)("/software/confluence/features");
    const signupLink = (0, $3FBn4.useLocalizedHref)("/try/cloud/signup?bundle=confluence");
    const { openCrossFlow: openCrossFlow } = (0, $3LLDq.useCrossFlowFrontendTouchpoint)({
        productKey: (0, $i8kxh.ProductKeys).CONFLUENCE,
        edition: (0, $i8kxh.Editions).FREE,
        redirectUrl: signupLink
    });
    const { ref: ref } = (0, $ccYBS.useScrollTracking)("ScrollerSection", {
        observerOptions: {
            threshold: 0.1
        }
    });
    const items = [
        {
            id: "1-files",
            title: intl.formatMessage({
                id: "ConfluenceSoftwarePage.v4.scroller.1.title",
                defaultMessage: "From files to freedom"
            }),
            description: intl.formatMessage({
                id: "ConfluenceSoftwarePage.v4.scroller.1.description",
                defaultMessage: "Create dynamic Pages with all kinds of content, like Whiteboards, Databases, and videos. Pull in all your work to reduce context-switching."
            }),
            feature: {
                src: "https://wac-cdn.atlassian.com/misc-assets/webp-images/confluence/confluence-scroll-2.webp",
                alt: intl.formatMessage({
                    id: "ConfluenceSoftwarePage.v4.scroller.1.imgAlt",
                    defaultMessage: "image of a confluence page"
                })
            },
            bgColor: (0, $5ohHq.wacToken)("color.primary.lime"),
            lazyLoadImage: true,
            bgShape: "0% 29%, 42% 28%, 43% 5%, 100% 0%, 100% 95%, 60% 95%, 60% 100%, 2% 93%, 2% 93%, 2% 93%",
            link: {
                type: "link",
                text: intl.formatMessage({
                    id: "ConfluenceSoftwarePage.v4.scroller.1.linkText",
                    defaultMessage: "See more features"
                }),
                label: "see-more-features",
                labelEnglish: "See more features",
                href: featuresLink,
                ariaLabelText: intl.formatMessage({
                    id: "ConfluenceSoftwarePage.v4.scroller.1.linkAriaLabel",
                    defaultMessage: "See more features of Confluence"
                })
            }
        },
        {
            id: "2-work",
            title: intl.formatMessage({
                id: "ConfluenceSoftwarePage.v4.scroller.2.title",
                defaultMessage: "Your shortcut for accelerating work"
            }),
            description: intl.formatMessage({
                id: "ConfluenceSoftwarePage.v4.scroller.2.description",
                defaultMessage: "Eliminate writer\u2019s block, automate repetitive tasks, and summarize lengthy docs with AI."
            }),
            feature: {
                src: "https://wac-cdn.atlassian.com/misc-assets/webp-images/confluence/confluence-scroll-1-updated.webp",
                alt: intl.formatMessage({
                    id: "ConfluenceSoftwarePage.v4.scroller.2.imgAlt",
                    defaultMessage: "image of Atlassian Intelligence on a confluence page"
                })
            },
            bgColor: (0, $5ohHq.wacToken)("color.primary.purple"),
            lazyLoadImage: true,
            bgShape: "6% 28%, 52% 23%, 53% 5%, 100% 0%, 100% 99%, 6% 96%, 6% 89%, 0% 88%, 0% 51%, 7% 50%",
            link: intl.locale === "en" ? {
                type: "link",
                text: intl.formatMessage({
                    id: "ConfluenceSoftwarePage.v4.scroller.2.linkText",
                    defaultMessage: "Try it out"
                }),
                label: "try-it-out",
                labelEnglish: "Try it out",
                href: "https://www.atlassian.com/confluence-sandbox-editor",
                ariaLabelText: intl.formatMessage({
                    id: "ConfluenceSoftwarePage.v4.scroller.2.linkAriaLabel",
                    defaultMessage: "Try out Confluence for free"
                })
            } : undefined
        },
        {
            id: "3-teams",
            title: intl.formatMessage({
                id: "ConfluenceSoftwarePage.v4.scroller.3.title",
                defaultMessage: "Connect the dots across your teams"
            }),
            description: intl.formatMessage({
                id: "ConfluenceSoftwarePage.v4.scroller.3.description",
                defaultMessage: "Build a source of truth for all teams. Stay caught up across your company with organized content and knowledge that's easily findable and always up-to-date."
            }),
            feature: {
                src: "https://wac-cdn.atlassian.com/misc-assets/webp-images/confluence/confluence-scroll-3.webp",
                alt: intl.formatMessage({
                    id: "ConfluenceSoftwarePage.v4.scroller.3.imgAlt",
                    defaultMessage: "image of a deliverable & outcomes document in confluence"
                })
            },
            bgColor: (0, $5ohHq.wacToken)("color.primary.yellow"),
            lazyLoadImage: true,
            bgShape: "0% 25%, 42% 20%, 42% 5%, 100% 0%, 100% 95%, 51% 100%, 50% 94%, 3% 95%, 3% 95%, 3% 95%",
            link: {
                type: "button",
                text: intl.formatMessage({
                    id: "ConfluenceSoftwarePage.v4.scroller.3.linkText",
                    defaultMessage: "Get started free"
                }),
                label: "get-started-free",
                labelEnglish: "Get started free",
                href: signupLink,
                onClick: openCrossFlow,
                ariaLabelText: intl.formatMessage({
                    id: "ConfluenceSoftwarePage.v4.scroller.3.linkAriaLabel",
                    defaultMessage: "Get started with Confluence for free"
                })
            }
        }
    ];
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $dyZbY.default), {
        name: "confluence-pt-cfind-1234-scrollerSection",
        children: /*#__PURE__*/ (0, $loA2J.jsx)("section", {
            ref: ref,
            className: (0, $esG4f.default)([
                "_1reozryt _18m9zryt"
            ]),
            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $ElG1F.Scroller), {
                items: items,
                renderText: (item)=>/*#__PURE__*/ (0, $loA2J.jsx)($feea6953423682aa$var$ScrollerContent, {
                        item: item
                    }),
                renderGraphic: (item, activeIndex, mobileSpecific)=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $4RMnv.Adg4FramedImage), {
                        feature: item.feature,
                        accent: item.accent,
                        bgShape: item.bgShape,
                        bgColor: item.bgColor,
                        lazyLoadImage: item.lazyLoadImage,
                        activeIndexIsEven: !mobileSpecific ? activeIndex % 2 === 0 : undefined
                    }),
                layout: "right",
                mobileGraphicLayout: "above",
                backgroundColor: "#fff",
                inScrollBackgroundColor: "#fff",
                heading: /*#__PURE__*/ (0, $loA2J.jsx)("h2", {
                    className: (0, $esG4f.default)([
                        "_y3gn1h6o _1bsb1osq"
                    ]),
                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                        id: "ConfluenceSoftwarePage.v4.scroller.heading",
                        defaultMessage: "Your team\u2019s knowledge, all in one place"
                    })
                })
            })
        })
    });
};
var $feea6953423682aa$export$2e2bcd8739ae039 = $feea6953423682aa$var$ScrollerSection;

});
parcelRegister("6VNwL", function(module, exports) {
$parcel$export(module.exports, "Adg4FramedImage", function () { return (parcelRequire("4RMnv")).Adg4FramedImage; });
parcelRequire("4RMnv");

});
parcelRegister("4RMnv", function(module, exports) {

$parcel$export(module.exports, "Adg4FramedImage", function () { return $d5aef9bf65e99142$export$3c140a884be9e13d; });
/* framed-image.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $cIqek = parcelRequire("cIqek");
const $d5aef9bf65e99142$export$3c140a884be9e13d = ({ feature: feature, accent: accent, bgShape: bgShape, bgColor: bgColor, activeIndexIsEven: activeIndexIsEven, lazyLoadImage: lazyLoadImage = false })=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: (0, $esG4f.default)([
            "_kqswh2mm"
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
            className: (0, $esG4f.default)([
                "_kqswh2mm _1h1t15ju"
            ]),
            children: [
                /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                    style: {
                        clipPath: `polygon(${bgShape})`,
                        backgroundColor: bgColor
                    },
                    className: (0, $esG4f.default)([
                        "_1bsb1osq _4t3i1osq _v564t24z _kqswstnw _1e02idpf _152tidpf",
                        activeIndexIsEven === true && "_y44v1cly",
                        activeIndexIsEven === false && "_y44vh8q8"
                    ])
                }),
                accent ? /*#__PURE__*/ (0, $loA2J.jsx)("img", {
                    src: accent.src,
                    className: (0, $esG4f.default)([
                        "_1bsbx19p _kqswstnw _1e02idpf _u7co15qf",
                        activeIndexIsEven === true && "_y44vxsqx",
                        activeIndexIsEven === false && "_y44vgh22",
                        accent.className
                    ]),
                    alt: accent.alt,
                    loading: lazyLoadImage ? "lazy" : undefined
                }) : "",
                /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                    className: (0, $esG4f.default)([
                        "_kqswh2mm _1e0c1ule _4t3i1wug _1bsb1osq _ca0q19nj _u5f316gx _n3td19nj _19bv16gx _rtys1osq",
                        activeIndexIsEven === true && "_y44vxsqx",
                        activeIndexIsEven === false && "_y44vgh22"
                    ]),
                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $cIqek.Adg4RaisedMedia), {
                        children: /*#__PURE__*/ (0, $loA2J.jsx)("img", {
                            className: feature.className,
                            loading: lazyLoadImage ? "lazy" : undefined,
                            src: feature.src,
                            alt: feature.alt
                        })
                    })
                })
            ]
        })
    });
};
const $d5aef9bf65e99142$var$framedImageStyles = null;
const $d5aef9bf65e99142$var$imgRegion = null;
const $d5aef9bf65e99142$var$featureImageStyle = null;
const $d5aef9bf65e99142$var$accentImageStyle = null;
const $d5aef9bf65e99142$var$bgShapeStyle = null;
const $d5aef9bf65e99142$var$activeEvenBgStyle = null;
const $d5aef9bf65e99142$var$activeOddBgStyle = null;
const $d5aef9bf65e99142$var$activeEvenImgStyle = null;
const $d5aef9bf65e99142$var$activeOddImgStyle = null;

});



parcelRegister("k2Kr3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1baf6f5bc8ffb5b9$export$2e2bcd8739ae039; });

var $loA2J = parcelRequire("loA2J");

var $dyZbY = parcelRequire("dyZbY");

var $ePK74 = parcelRequire("ePK74");
const $1baf6f5bc8ffb5b9$var$SocialEndorsementSection = ()=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $dyZbY.default), {
        name: "confluence-pt-cfind-1234-socialEndorsementSection",
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $ePK74.SocialEndorsement), {})
    });
$1baf6f5bc8ffb5b9$var$SocialEndorsementSection.displayName = "SocialEndorsementSection";
var $1baf6f5bc8ffb5b9$export$2e2bcd8739ae039 = $1baf6f5bc8ffb5b9$var$SocialEndorsementSection;

});
parcelRegister("ePK74", function(module, exports) {

$parcel$export(module.exports, "SocialEndorsement", function () { return $e24bf2a7e867472b$export$782656e60c9cecfd; });
/* social-endorsement.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $4XrxY = parcelRequire("4XrxY");
const $e24bf2a7e867472b$var$logosContainerStyle = null;
const $e24bf2a7e867472b$var$logoStyle = null; /**
                         * @deprecated - Please use @/libraries/design/patterns/logos instead
                         */ 
const $e24bf2a7e867472b$export$782656e60c9cecfd = ()=>{
    const logos = [
        {
            src: "https://wac-cdn.atlassian.com/misc-assets/svgs/confluence/social-endorsement/canva.svg",
            alt: "Canva",
            width: 95
        },
        {
            src: "https://wac-cdn.atlassian.com/misc-assets/svgs/confluence/social-endorsement/nasa.svg",
            alt: "NASA",
            width: 60
        },
        {
            src: "https://wac-cdn.atlassian.com/misc-assets/svgs/confluence/social-endorsement/illumina.svg",
            alt: "Illumina",
            width: 103
        },
        {
            src: "https://wac-cdn.atlassian.com/misc-assets/svgs/confluence/social-endorsement/docker.svg",
            alt: "Docker",
            width: 108
        },
        {
            src: "https://wac-cdn.atlassian.com/misc-assets/svgs/confluence/social-endorsement/new-york-times.svg",
            alt: "The New York Times",
            width: 165
        },
        {
            src: "https://wac-cdn.atlassian.com/misc-assets/svgs/confluence/social-endorsement/audi.svg",
            alt: "Audi",
            width: 68
        }
    ];
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.Row), {
        children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
            className: (0, $esG4f.default)([
                "_6a6z1h6o _4cvr1h6o _1pfhckbl _6rthzwfg _195g1wug _1bsb1osq _10jx1fa8 _msupitcz _181n1txw _zkhy1g80 _e8gh1h6o _1to91tcg _99s6ckbl _14b51osq _j6qucv93 _suga11p5 _131y7vkz _1d4s1tcg _19d7910g _1rkbcv93 _1rfm1osq _1m0a11p5 _6j7rftgi _1dw37vkz _1s8mfsjm"
            ]),
            children: logos.map((logo, index)=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $iSvIT.Fragment), {
                    children: /*#__PURE__*/ (0, $loA2J.jsx)("img", {
                        src: logo.src,
                        alt: logo.alt,
                        loading: "lazy",
                        width: logo.width,
                        className: (0, $esG4f.default)([
                            "_lcxvglyw _kdamllbs _16bullbs _95u51cm0 _14dm2k2r"
                        ])
                    })
                }, index))
        })
    });
};

});


parcelRegister("gwC97", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2b0e4b0b946a9c03$export$2e2bcd8739ae039; });
/* templates-section.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $f6qj2 = parcelRequire("f6qj2");

var $dyZbY = parcelRequire("dyZbY");

var $cutM5 = parcelRequire("cutM5");

var $aLVH0 = parcelRequire("aLVH0");

var $1UUq1 = parcelRequire("1UUq1");

var $3FBn4 = parcelRequire("3FBn4");

var $4XrxY = parcelRequire("4XrxY");

var $7FUn6 = parcelRequire("7FUn6");

var $ccYBS = parcelRequire("ccYBS");

var $bijXJ = parcelRequire("bijXJ");
const $2b0e4b0b946a9c03$var$tabsWrapper = null;
const $2b0e4b0b946a9c03$var$headingStyle = null;
const $2b0e4b0b946a9c03$var$linkStyle = null; // Prevent height jump when image is loading
const $2b0e4b0b946a9c03$var$contentHeight = null;
function $2b0e4b0b946a9c03$var$item(intl, title, description, imgSrc, templateLinkPrefix, templateSlug, lazyLoad = true) {
    const titleText = intl.formatMessage(title);
    const headingId = `${templateSlug}-heading`;
    const linkId = `${templateSlug}-link`;
    return {
        title: titleText,
        description: intl.formatMessage(description),
        expandAriaLabel: intl.formatMessage((0, $bijXJ.templatesSectionMessages).expandAriaLabel, {
            title: titleText
        }),
        content: // eslint-disable-next-line no-restricted-syntax
        /*#__PURE__*/ (0, $loA2J.jsx)("img", {
            alt: "",
            loading: lazyLoad ? "lazy" : undefined,
            src: imgSrc,
            width: "100%"
        }),
        link: /*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.Link), {
            text: intl.formatMessage((0, $bijXJ.templatesSectionMessages).tryItOut),
            href: templateLinkPrefix + "/" + templateSlug,
            dataEventProps: {
                "data-product-key": "confluence",
                "data-event": "clicked",
                "data-event-component": "linkButton",
                "data-event-container": "templatesSection",
                "data-label": templateSlug,
                "data-label-english": "Try it out",
                "data-track-event": "confluence-pt.templates.try-it-out"
            },
            id: linkId,
            ariaLabelledby: `${headingId} ${linkId}`
        }),
        dataEventProps: {
            "data-product-key": "confluence",
            "data-event": "clicked",
            "data-event-component": "carouselItem",
            "data-event-container": "templatesSection",
            "data-label": templateSlug,
            "data-label-english": typeof title.defaultMessage === "string" ? title.defaultMessage : undefined,
            "data-track-event": "confluence-pt.templates.list-item"
        },
        headingId: headingId
    };
}
const $2b0e4b0b946a9c03$var$TabContent = ({ category: category })=>{
    const { goToNextTab: goToNextTab, userSelected: userSelected } = (0, $cutM5.useAdg4TabsContext)();
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $7FUn6.ListContentCycle), {
        items: category.items,
        listHeading: category.categoryTitle,
        onCycleEnd: ()=>{
            if (!userSelected) goToNextTab();
        }
    });
};
const $2b0e4b0b946a9c03$var$TemplatesSection = ()=>{
    const intl = (0, $f6qj2.default)();
    const templatesLink = (0, $3FBn4.useLocalizedHref)("/software/confluence/templates");
    const templateCategories = [
        {
            tabName: intl.formatMessage((0, $bijXJ.templatesSectionMarketingMessages).tabName),
            categoryTitle: intl.formatMessage((0, $bijXJ.templatesSectionMarketingMessages).contentHeading),
            eventProps: {
                label: "marketing-and-sales",
                labelEnglish: "Marketing"
            },
            items: [
                $2b0e4b0b946a9c03$var$item(intl, (0, $bijXJ.templatesSectionMarketingMessages).template1Heading, (0, $bijXJ.templatesSectionMarketingMessages).template1Description, "https://wac-cdn.atlassian.com/misc-assets/webp-images/confluence/pt-templates/marketing-template-01-plan.webp", templatesLink, "marketing-plan"),
                $2b0e4b0b946a9c03$var$item(intl, (0, $bijXJ.templatesSectionMarketingMessages).template2Heading, (0, $bijXJ.templatesSectionMarketingMessages).template2Description, "https://wac-cdn.atlassian.com/misc-assets/webp-images/confluence/pt-templates/marketing-template-02-competitive-analysis.webp", templatesLink, "competitive-analysis"),
                $2b0e4b0b946a9c03$var$item(intl, (0, $bijXJ.templatesSectionMarketingMessages).template3Heading, (0, $bijXJ.templatesSectionMarketingMessages).template3Description, "https://wac-cdn.atlassian.com/misc-assets/webp-images/confluence/pt-templates/marketing-template-03-campaign.webp", templatesLink, "marketing-campaign")
            ]
        },
        {
            tabName: intl.formatMessage((0, $bijXJ.templatesSectionProjectPlanningMessages).tabName),
            categoryTitle: intl.formatMessage((0, $bijXJ.templatesSectionProjectPlanningMessages).contentHeading),
            eventProps: {
                label: "project-planning",
                labelEnglish: "Project Planning"
            },
            items: [
                $2b0e4b0b946a9c03$var$item(intl, (0, $bijXJ.templatesSectionProjectPlanningMessages).template1Heading, (0, $bijXJ.templatesSectionProjectPlanningMessages).template1Description, "https://wac-cdn.atlassian.com/misc-assets/webp-images/confluence/pt-templates/project-planning-template-01-brainstorm.webp", templatesLink, "brainstorming"),
                $2b0e4b0b946a9c03$var$item(intl, (0, $bijXJ.templatesSectionProjectPlanningMessages).template2Heading, (0, $bijXJ.templatesSectionProjectPlanningMessages).template2Description, "https://wac-cdn.atlassian.com/misc-assets/webp-images/confluence/pt-templates/project-planning-template-02-plan.webp", templatesLink, "project-plan"),
                $2b0e4b0b946a9c03$var$item(intl, (0, $bijXJ.templatesSectionProjectPlanningMessages).template3Heading, (0, $bijXJ.templatesSectionProjectPlanningMessages).template3Description, "https://wac-cdn.atlassian.com/misc-assets/webp-images/confluence/pt-templates/project-planning-template-03-roles.webp", templatesLink, "roles-and-responsibilities")
            ]
        },
        {
            tabName: intl.formatMessage((0, $bijXJ.templatesSectionSoftwareMessages).tabName),
            categoryTitle: intl.formatMessage((0, $bijXJ.templatesSectionSoftwareMessages).contentHeading),
            eventProps: {
                label: "software-development",
                labelEnglish: "Software"
            },
            items: [
                $2b0e4b0b946a9c03$var$item(intl, (0, $bijXJ.templatesSectionSoftwareMessages).template1Heading, (0, $bijXJ.templatesSectionSoftwareMessages).template1Description, "https://wac-cdn.atlassian.com/misc-assets/webp-images/confluence/pt-templates/software-template-01-sprint-planning.webp", templatesLink, "sprint-planning-meeting"),
                $2b0e4b0b946a9c03$var$item(intl, (0, $bijXJ.templatesSectionSoftwareMessages).template2Heading, (0, $bijXJ.templatesSectionSoftwareMessages).template2Description, "https://wac-cdn.atlassian.com/misc-assets/webp-images/confluence/pt-templates/software-template-02-experiment-plan.webp", templatesLink, "experiment-plan-and-results"),
                $2b0e4b0b946a9c03$var$item(intl, (0, $bijXJ.templatesSectionSoftwareMessages).template3Heading, (0, $bijXJ.templatesSectionSoftwareMessages).template3Description, "https://wac-cdn.atlassian.com/misc-assets/webp-images/confluence/pt-templates/software-template-03-devops-runbook.webp", templatesLink, "devops-runbook")
            ]
        },
        {
            tabName: intl.formatMessage((0, $bijXJ.templatesSectionProductManagementMessages).tabName),
            categoryTitle: intl.formatMessage((0, $bijXJ.templatesSectionProductManagementMessages).contentHeading),
            eventProps: {
                label: "product-management",
                labelEnglish: "Product Management"
            },
            items: [
                $2b0e4b0b946a9c03$var$item(intl, (0, $bijXJ.templatesSectionProductManagementMessages).template1Heading, (0, $bijXJ.templatesSectionProductManagementMessages).template1Description, "https://wac-cdn.atlassian.com/misc-assets/webp-images/confluence/pt-templates/product-template-01-requirements.webp", templatesLink, "product-requirements"),
                $2b0e4b0b946a9c03$var$item(intl, (0, $bijXJ.templatesSectionProductManagementMessages).template2Heading, (0, $bijXJ.templatesSectionProductManagementMessages).template2Description, "https://wac-cdn.atlassian.com/misc-assets/webp-images/confluence/pt-templates/product-template-02-roadmap.webp", templatesLink, "product-roadmap"),
                $2b0e4b0b946a9c03$var$item(intl, (0, $bijXJ.templatesSectionProductManagementMessages).template3Heading, (0, $bijXJ.templatesSectionProductManagementMessages).template3Description, "https://wac-cdn.atlassian.com/misc-assets/webp-images/confluence/pt-templates/product-template-03-launch.webp", templatesLink, "product-launch")
            ]
        },
        {
            tabName: intl.formatMessage((0, $bijXJ.templatesSectionBusinessStrategyMessages).tabName),
            categoryTitle: intl.formatMessage((0, $bijXJ.templatesSectionBusinessStrategyMessages).contentHeading),
            eventProps: {
                label: "business-strategy",
                labelEnglish: "Business Strategy"
            },
            items: [
                $2b0e4b0b946a9c03$var$item(intl, (0, $bijXJ.templatesSectionBusinessStrategyMessages).template1Heading, (0, $bijXJ.templatesSectionBusinessStrategyMessages).template1Description, "https://wac-cdn.atlassian.com/misc-assets/webp-images/confluence/pt-templates/bus-strategy-template-01-vision.webp", templatesLink, "vision-to-values"),
                $2b0e4b0b946a9c03$var$item(intl, (0, $bijXJ.templatesSectionBusinessStrategyMessages).template2Heading, (0, $bijXJ.templatesSectionBusinessStrategyMessages).template2Description, "https://wac-cdn.atlassian.com/misc-assets/webp-images/confluence/pt-templates/bus-strategy-template-02-strategic-plan.webp", templatesLink, "strategic-plan"),
                $2b0e4b0b946a9c03$var$item(intl, (0, $bijXJ.templatesSectionBusinessStrategyMessages).template3Heading, (0, $bijXJ.templatesSectionBusinessStrategyMessages).template3Description, "https://wac-cdn.atlassian.com/misc-assets/webp-images/confluence/pt-templates/bus-strategy-template-03-updates.webp", templatesLink, "business-status-update")
            ]
        }
    ];
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $dyZbY.default), {
        name: "confluence-pt-cfind-1234-templatesSection",
        children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
            className: (0, $esG4f.default)([
                "_kqswh2mm _1pbykb7n _1xgm1crf _vnhn1ylp _x3vx7vkz _zfbj1f4h"
            ]),
            children: [
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.Row), {
                    children: /*#__PURE__*/ (0, $loA2J.jsx)("h2", {
                        className: (0, $esG4f.default)([
                            "_y3gn1h6o _6rthidpf"
                        ]),
                        children: intl.formatMessage((0, $bijXJ.templatesSectionMessages).heading)
                    })
                }),
                /*#__PURE__*/ (0, $loA2J.jsxs)((0, $cutM5.Adg4Tabs), {
                    children: [
                        /*#__PURE__*/ (0, $loA2J.jsx)((0, $cutM5.Adg4DraggableTabList), {
                            className: "tab-list",
                            children: templateCategories.map((category, index)=>{
                                return /*#__PURE__*/ (0, $loA2J.jsx)((0, $cutM5.Adg4DraggableTab), {
                                    className: "round-tab",
                                    dataEventProps: {
                                        "data-product-key": "confluence",
                                        "data-event": "clicked",
                                        "data-event-component": "tab",
                                        "data-event-container": "templatesSection",
                                        "data-label": category.eventProps.label,
                                        "data-label-english": category.eventProps.labelEnglish,
                                        "data-track-event": "confluence-pt.templates.tab"
                                    },
                                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $aLVH0.RoundTab), {
                                        title: category.tabName
                                    })
                                }, index);
                            })
                        }),
                        templateCategories.map((category, index)=>{
                            return /*#__PURE__*/ (0, $loA2J.jsx)((0, $cutM5.Adg4TabPanel), {
                                children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                    className: (0, $esG4f.default)([
                                        "_19451pl1"
                                    ]),
                                    children: /*#__PURE__*/ (0, $loA2J.jsx)($2b0e4b0b946a9c03$var$TabContent, {
                                        category: category
                                    })
                                })
                            }, index);
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.Row), {
                    children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                        className: (0, $esG4f.default)([
                            "_1k9pzwfg _1tntvbgk"
                        ]),
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.Link), {
                            text: intl.formatMessage((0, $bijXJ.templatesSectionMessages).seeAllTemplates),
                            href: templatesLink,
                            dataEventProps: {
                                "data-product-key": "confluence",
                                "data-event": "clicked",
                                "data-event-component": "linkButton",
                                "data-event-container": "templatesSection",
                                "data-label": "see-all-templates",
                                "data-label-english": "See all templates",
                                "data-track-event": "confluence-pt.templates.see-all-templates"
                            }
                        })
                    })
                })
            ]
        })
    });
};
var $2b0e4b0b946a9c03$export$2e2bcd8739ae039 = (0, $ccYBS.withScrollTracking)("TemplatesSection", $2b0e4b0b946a9c03$var$TemplatesSection, {
    observerOptions: {
        threshold: 0.1
    }
});

});
parcelRegister("aLVH0", function(module, exports) {

$parcel$export(module.exports, "RoundTab", function () { return $c294bc0cb36a86e5$export$e748343268edd19c; });
/* round-tab.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $5ohHq = parcelRequire("5ohHq");
const $c294bc0cb36a86e5$var$tabStyle = null;
const $c294bc0cb36a86e5$var$selectedTabStyle = null;
const $c294bc0cb36a86e5$export$e748343268edd19c = ({ isSelected: isSelected, title: title })=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: (0, $esG4f.default)([
            "_bfhk150w _4cvr1h6o _1bah1h6o _vchhusvi _1e0c1txw _y3gn1h6o _4bfu1r31 _1hmsglyw _ajmmnqa1 _4t3i8vuz _2rko1f4h _y4tigktf _bozggktf _80omtlke _19itzv82 _k48pbfng _1wyb1k92 _ect41pz4 _bfw71tdf _irr31ybm",
            isSelected && "_19it1tdf _syazvb1l"
        ]),
        style: {
            "--_8nj8hf": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light200")),
            "--_1h6bnby": (0, $43MIc.default)((0, $5ohHq.wacToken)("font.charlie.display")),
            "--_1hkddbi": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.extended.blue100"))
        },
        children: title
    });
};

});

parcelRegister("7FUn6", function(module, exports) {

$parcel$export(module.exports, "ListContentCycle", function () { return $f31f755f3691dbba$export$d6db5cefb2f41a42; });
/* list-content-cycle.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $eDoPe = parcelRequire("eDoPe");

var $5ohHq = parcelRequire("5ohHq");

var $4XrxY = parcelRequire("4XrxY");
const $f31f755f3691dbba$var$wrapperStyle = null;
const $f31f755f3691dbba$var$contentWrapper = null;
const $f31f755f3691dbba$var$textItemStyles = null;
const $f31f755f3691dbba$var$graphicStyles = null;
const $f31f755f3691dbba$var$itemContainer = null;
const $f31f755f3691dbba$var$itemStyles = null;
const $f31f755f3691dbba$var$buttonStyle = null;
const $f31f755f3691dbba$var$headingStyle = null;
const $f31f755f3691dbba$var$noMarginStyle = null;
const $f31f755f3691dbba$var$textLinkStyle = null;
const $f31f755f3691dbba$var$visibleTextLink = null;
const $f31f755f3691dbba$var$progressBar = null;
const $f31f755f3691dbba$var$barFillStyle = null;
const $f31f755f3691dbba$var$fullBarStyle = null;
const $f31f755f3691dbba$var$mobileContentStyles = null;
const $f31f755f3691dbba$var$contentStyles = null;
const $f31f755f3691dbba$var$activeContentMedia = null;
const $f31f755f3691dbba$var$activeContentStyle = null; /**
                                  * @deprecated - Please use @/libraries/design/patterns/features-highlight instead
                                  */ 
const $f31f755f3691dbba$export$d6db5cefb2f41a42 = ({ items: items, heading: heading, listHeading: listHeading, duration: duration = 5000, onCycleEnd: onCycleEnd })=>{
    const { ref: scrollRef, inView: sectionIsVisible } = (0, $eDoPe.useInView)();
    const [activeItem, setActiveItem] = (0, $iSvIT.useState)(0);
    const [userSelected, setUserSelected] = (0, $iSvIT.useState)(false);
    const animation = null;
    const changeActive = (index, setSelected = false)=>{
        if (onCycleEnd && index >= items.length) onCycleEnd();
        if (setSelected) setUserSelected(true);
        setActiveItem(index >= items.length ? 0 : index);
    }; // resume loop after comes back into view
    (0, $iSvIT.useEffect)(()=>{
        if (sectionIsVisible) setUserSelected(false);
    }, [
        sectionIsVisible
    ]);
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.Row), {
        children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
            ref: scrollRef,
            className: (0, $esG4f.default)([]),
            children: [
                heading && /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                    className: (0, $esG4f.default)([
                        "_85i51tcg"
                    ]),
                    children: heading
                }),
                /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                    className: (0, $esG4f.default)([
                        "_1e0c1txw _2lx2vrvc _zulpys9h"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                            className: (0, $esG4f.default)([
                                "_1e0c1txw _2lx21bp4 _zulpzwfg _16jlidpf _1o9zidpf _i0dl1osq _10m4idpf _1vdkidpf _1wzn19wn"
                            ]),
                            children: [
                                listHeading && /*#__PURE__*/ (0, $loA2J.jsx)("h3", {
                                    className: (0, $esG4f.default)([
                                        "_19pkidpf _2hwxidpf _otyridpf _18u0idpf"
                                    ]),
                                    children: listHeading
                                }),
                                items.map((item, index)=>{
                                    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                                        className: (0, $esG4f.default)([
                                            "_kqswh2mm"
                                        ]),
                                        children: [
                                            /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                                                className: (0, $esG4f.default)([
                                                    "_kqswh2mm _1e0c1txw _2lx21bp4 _y3gnv2br _bozg1tcg"
                                                ]),
                                                children: [
                                                    /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                                        className: (0, $esG4f.default)([
                                                            "_kqswstnw _152tidpf _u7coidpf _1e02idpf _1bsb1l7b _bfhk1kby"
                                                        ]),
                                                        children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                                            onAnimationEnd: ()=>{
                                                                if (userSelected) return;
                                                                changeActive(index + 1);
                                                            },
                                                            className: (0, $esG4f.default)([
                                                                "_11q717la _4t3iidpf",
                                                                sectionIsVisible && !userSelected && activeItem === index && "_y44v1she",
                                                                userSelected && activeItem === index && "_4t3i1osq"
                                                            ]),
                                                            style: {
                                                                "--_1r6llbg": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.blue")),
                                                                "--_1bg9z7q": (0, $43MIc.default)(duration, "ms")
                                                            }
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $loA2J.jsx)("button", (0, $6iHNw._)((0, $7Knp0._)({
                                                        "aria-label": item.expandAriaLabel,
                                                        "aria-expanded": activeItem === index,
                                                        onClick: ()=>{
                                                            changeActive(index, true);
                                                        }
                                                    }, item.dataEventProps), {
                                                        className: (0, $esG4f.default)([
                                                            "_y3gn1e5h _11q7glyw _r06hglyw _1r04idpf _80omtlke _19itidpf _18zridpf _1rjcidpf"
                                                        ]),
                                                        children: /*#__PURE__*/ (0, $loA2J.jsx)("h4", {
                                                            id: item.headingId,
                                                            className: (0, $esG4f.default)([
                                                                "_19pkidpf _2hwxidpf _otyridpf _18u0idpf"
                                                            ]),
                                                            children: item.title
                                                        })
                                                    })),
                                                    /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                                                        className: (0, $esG4f.default)([
                                                            "_1e0c1txw _2lx21bp4 _zulpftgi _v5641tqq _c71lidpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1reo15vq _18m915vq",
                                                            activeItem === index && "_c71lmgvx _1rjc1y44"
                                                        ]),
                                                        children: [
                                                            /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                                                                className: (0, $esG4f.default)([
                                                                    "_19pkidpf _2hwxidpf _otyridpf _18u0idpf"
                                                                ]),
                                                                children: item.description
                                                            }),
                                                            item.link
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                                className: (0, $esG4f.default)([
                                                    "_v564ayzn _1e0cglyw _1reo15vq _18m915vq _tzy4idpf _1rjc7vkz",
                                                    activeItem === index && "_tzy4kb7n _1mjb1ule"
                                                ]),
                                                children: item.content
                                            })
                                        ]
                                    }, index);
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                            className: (0, $esG4f.default)([
                                "_16jlkb7n _1o9zkb7n _i0dlf1ug"
                            ]),
                            children: items.map((item, index)=>{
                                return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                    className: (0, $esG4f.default)([
                                        "_v564ayzn _1lww1yx9 _4t3iidpf _tzy4idpf _1reo15vq _18m915vq _1mjbglyw",
                                        activeItem === index && "_4t3i1wug _tzy4kb7n _dm251ule"
                                    ]),
                                    children: item.content
                                }, index);
                            })
                        })
                    ]
                })
            ]
        })
    });
};

});

parcelRegister("bijXJ", function(module, exports) {

$parcel$export(module.exports, "templatesSectionMessages", function () { return $1a54216331c800ea$export$918efc24479364d; });
$parcel$export(module.exports, "templatesSectionMarketingMessages", function () { return $1a54216331c800ea$export$217732740ce81bfa; });
$parcel$export(module.exports, "templatesSectionProjectPlanningMessages", function () { return $1a54216331c800ea$export$6b54437a0a39225d; });
$parcel$export(module.exports, "templatesSectionSoftwareMessages", function () { return $1a54216331c800ea$export$4c78b2adf33c9c13; });
$parcel$export(module.exports, "templatesSectionProductManagementMessages", function () { return $1a54216331c800ea$export$b3ac84acded839df; });
$parcel$export(module.exports, "templatesSectionBusinessStrategyMessages", function () { return $1a54216331c800ea$export$d594459a0e83d76e; });

var $6x1qA = parcelRequire("6x1qA");
const $1a54216331c800ea$export$918efc24479364d = (0, $6x1qA.defineMessages)({
    heading: {
        id: "ConfluenceSoftwarePage.v4.TemplatesSection.heading",
        defaultMessage: "Confluence is for every team"
    },
    seeAllTemplates: {
        id: "ConfluenceSoftwarePage.v4.TemplatesSection.seeAllTemplates",
        defaultMessage: "See all templates"
    },
    tryItOut: {
        id: "ConfluenceSoftwarePage.v4.TemplatesSection.tryItOut",
        defaultMessage: "Try it out"
    },
    expandAriaLabel: {
        id: "ConfluenceSoftwarePage.v4.TemplatesSection.expandAriaLabel",
        defaultMessage: "Expand {title}"
    },
    imgAlt: {
        id: "ConfluenceSoftwarePage.v4.TemplatesSection.imgAlt",
        defaultMessage: "Image of {title} template"
    }
});
const $1a54216331c800ea$export$217732740ce81bfa = (0, $6x1qA.defineMessages)({
    tabName: {
        id: "ConfluenceSoftwarePage.v4.ContentTypes.Marketing.tabName",
        defaultMessage: "Marketing"
    },
    contentHeading: {
        id: "ConfluenceSoftwarePage.v4.ContentTypes.Marketing.heading",
        defaultMessage: "Templates for marketing teams"
    },
    template1Heading: {
        id: "ConfluenceSoftwarePage.v4.ContentTypes.Marketing.template1.heading",
        defaultMessage: "Marketing plan"
    },
    template1Description: {
        id: "ConfluenceSoftwarePage.v4.ContentTypes.Marketing.template1.description",
        defaultMessage: "Nail your GTM strategy and plan marketing programs with your team"
    },
    template2Heading: {
        id: "ConfluenceSoftwarePage.v4.ContentTypes.Marketing.template2.heading",
        defaultMessage: "Competitive analysis"
    },
    template2Description: {
        id: "ConfluenceSoftwarePage.v4.ContentTypes.Marketing.template2.description",
        defaultMessage: "Collaboratively document competitor offerings & strategies"
    },
    template3Heading: {
        id: "ConfluenceSoftwarePage.v4.ContentTypes.Marketing.template3.heading",
        defaultMessage: "Marketing campaign"
    },
    template3Description: {
        id: "ConfluenceSoftwarePage.v4.ContentTypes.Marketing.template3.description",
        defaultMessage: "Build a solid campaign blueprint to drive impact"
    }
});
const $1a54216331c800ea$export$6b54437a0a39225d = (0, $6x1qA.defineMessages)({
    tabName: {
        id: "ConfluenceSoftwarePage.v4.ContentTypes.ProjectPlanning.tabName",
        defaultMessage: "Project Planning"
    },
    contentHeading: {
        id: "ConfluenceSoftwarePage.v4.ContentTypes.ProjectPlanning.heading",
        defaultMessage: "Templates for project planning"
    },
    template1Heading: {
        id: "ConfluenceSoftwarePage.v4.ContentTypes.ProjectPlanning.template1.heading",
        defaultMessage: "Brainstorm"
    },
    template1Description: {
        id: "ConfluenceSoftwarePage.v4.ContentTypes.ProjectPlanning.template1.description",
        defaultMessage: "Lead a productive brainstorming session and ideate on the most impactful work"
    },
    template2Heading: {
        id: "ConfluenceSoftwarePage.v4.ContentTypes.ProjectPlanning.template2.heading",
        defaultMessage: "Project plan"
    },
    template2Description: {
        id: "ConfluenceSoftwarePage.v4.ContentTypes.ProjectPlanning.template2.description",
        defaultMessage: "Map out your project logistics and move your team across the finish line, every time."
    },
    template3Heading: {
        id: "ConfluenceSoftwarePage.v4.ContentTypes.ProjectPlanning.template3.heading",
        defaultMessage: "Roles & responsibilities"
    },
    template3Description: {
        id: "ConfluenceSoftwarePage.v4.ContentTypes.ProjectPlanning.template3.description",
        defaultMessage: "Clarify individual roles and responsibilities to build a strong project team"
    }
});
const $1a54216331c800ea$export$4c78b2adf33c9c13 = (0, $6x1qA.defineMessages)({
    tabName: {
        id: "ConfluenceSoftwarePage.v4.ContentTypes.Software.tabName",
        defaultMessage: "Software"
    },
    contentHeading: {
        id: "ConfluenceSoftwarePage.v4.ContentTypes.Software.heading",
        defaultMessage: "Templates for software teams"
    },
    template1Heading: {
        id: "ConfluenceSoftwarePage.v4.ContentTypes.Software.template1.heading",
        defaultMessage: "Sprint planning"
    },
    template1Description: {
        id: "ConfluenceSoftwarePage.v4.ContentTypes.Software.template1.description",
        defaultMessage: "Set goals, plan team capacity, and effectively kick off every sprint"
    },
    template2Heading: {
        id: "ConfluenceSoftwarePage.v4.ContentTypes.Software.template2.heading",
        defaultMessage: "Experiment plan"
    },
    template2Description: {
        id: "ConfluenceSoftwarePage.v4.ContentTypes.Software.template2.description",
        defaultMessage: "Streamline your experiment process to more effectively test and learn"
    },
    template3Heading: {
        id: "ConfluenceSoftwarePage.v4.ContentTypes.Software.template3.heading",
        defaultMessage: "DevOps runbook"
    },
    template3Description: {
        id: "ConfluenceSoftwarePage.v4.ContentTypes.Software.template3.description",
        defaultMessage: "Help your operations team respond to system alerts and outages"
    }
});
const $1a54216331c800ea$export$b3ac84acded839df = (0, $6x1qA.defineMessages)({
    tabName: {
        id: "ConfluenceSoftwarePage.v4.ContentTypes.ProductManagement.tabName",
        defaultMessage: "Product Management"
    },
    contentHeading: {
        id: "ConfluenceSoftwarePage.v4.ContentTypes.ProductManagement.heading",
        defaultMessage: "Templates for product management"
    },
    template1Heading: {
        id: "ConfluenceSoftwarePage.v4.ContentTypes.ProductManagement.template1.heading",
        defaultMessage: "Product requirements"
    },
    template1Description: {
        id: "ConfluenceSoftwarePage.v4.ContentTypes.ProductManagement.template1.description",
        defaultMessage: "Outline your pre-launch prep and track your post-launch progress"
    },
    template2Heading: {
        id: "ConfluenceSoftwarePage.v4.ContentTypes.ProductManagement.template2.heading",
        defaultMessage: "Product roadmap"
    },
    template2Description: {
        id: "ConfluenceSoftwarePage.v4.ContentTypes.ProductManagement.template2.description",
        defaultMessage: "Transform your product features from ideas to reality"
    },
    template3Heading: {
        id: "ConfluenceSoftwarePage.v4.ContentTypes.ProductManagement.template3.heading",
        defaultMessage: "Product launch"
    },
    template3Description: {
        id: "ConfluenceSoftwarePage.v4.ContentTypes.ProductManagement.template3.description",
        defaultMessage: "Your ultimate liftoff planning doc"
    }
});
const $1a54216331c800ea$export$d594459a0e83d76e = (0, $6x1qA.defineMessages)({
    tabName: {
        id: "ConfluenceSoftwarePage.v4.ContentTypes.BusinessStrategy.tabName",
        defaultMessage: "Business Strategy"
    },
    contentHeading: {
        id: "ConfluenceSoftwarePage.v4.ContentTypes.BusinessStrategy.heading",
        defaultMessage: "Templates for business strategy"
    },
    template1Heading: {
        id: "ConfluenceSoftwarePage.v4.ContentTypes.BusinessStrategy.template1.heading",
        defaultMessage: "Vision to values"
    },
    template1Description: {
        id: "ConfluenceSoftwarePage.v4.ContentTypes.BusinessStrategy.template1.description",
        defaultMessage: "Align business strategies with company mission"
    },
    template2Heading: {
        id: "ConfluenceSoftwarePage.v4.ContentTypes.BusinessStrategy.template2.heading",
        defaultMessage: "Strategic plan"
    },
    template2Description: {
        id: "ConfluenceSoftwarePage.v4.ContentTypes.BusinessStrategy.template2.description",
        defaultMessage: "Turn your business vision into actionable next steps"
    },
    template3Heading: {
        id: "ConfluenceSoftwarePage.v4.ContentTypes.BusinessStrategy.template3.heading",
        defaultMessage: "Business status updates"
    },
    template3Description: {
        id: "ConfluenceSoftwarePage.v4.ContentTypes.BusinessStrategy.template3.description",
        defaultMessage: "Share performance results and customer insights across the team"
    }
});

});


parcelRegister("lpMJ8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8af0183533d4b69f$export$2e2bcd8739ae039; });
/* testimonial-section.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $f6qj2 = parcelRequire("f6qj2");

var $dyZbY = parcelRequire("dyZbY");

var $91nJf = parcelRequire("91nJf");

var $3FBn4 = parcelRequire("3FBn4");

var $1HoZL = parcelRequire("1HoZL");

var $8z7A0 = parcelRequire("8z7A0");
const $8af0183533d4b69f$var$logoSizeStyles = null;
const $8af0183533d4b69f$var$TestimonialsSection = ()=>{
    const intl = (0, $f6qj2.default)();
    const testimonials = [
        {
            name: intl.formatMessage({
                id: "ConfluenceSoftwarePage.v4.testimonials.testimonialDropbox.name",
                defaultMessage: "Damien Davis"
            }),
            logo: /*#__PURE__*/ (0, $loA2J.jsx)((0, $8z7A0.TestimonialDropbox), {}),
            title: intl.formatMessage({
                id: "ConfluenceSoftwarePage.v4.testimonials.testimonialDropbox.title",
                defaultMessage: "Lead Atlassian Administrator, Dropbox"
            }),
            image: "https://wac-cdn.atlassian.com/misc-assets/webp-images/confluence/testimonial-dropbox.webp",
            quote: intl.formatMessage({
                id: "ConfluenceSoftwarePage.v4.testimonials.testimonialDropbox.quote",
                defaultMessage: "Confluence out of the box is a fantastic product, and integrations take it to another level. We can embed videos, media, and all sorts of files and make them accessible across the enterprise."
            }),
            label: "Dropbox"
        },
        {
            name: intl.formatMessage({
                id: "ConfluenceSoftwarePage.v4.testimonials.testimonialRoblox.name",
                defaultMessage: "Joe Cotant"
            }),
            logo: /*#__PURE__*/ (0, $loA2J.jsx)((0, $8z7A0.TestimonialRoblox), {}),
            title: intl.formatMessage({
                id: "ConfluenceSoftwarePage.v4.testimonials.testimonialRoblox.title",
                defaultMessage: "Senior Technical Program Manager, Roblox"
            }),
            image: "https://wac-cdn.atlassian.com/misc-assets/webp-images/confluence/testimonial-roblox.webp",
            quote: intl.formatMessage({
                id: "ConfluenceSoftwarePage.v4.testimonials.testimonialRoblox.quote",
                defaultMessage: "Using smart links within Confluence and Jira makes cross-team collaboration much easier. These integrations have been pivotal in collaboration, productivity, and discoverability."
            }),
            label: "Roblox"
        },
        {
            name: intl.formatMessage({
                id: "ConfluenceSoftwarePage.v4.testimonials.testimonialLumen.name",
                defaultMessage: "Rob Mulvaney"
            }),
            logo: /*#__PURE__*/ (0, $loA2J.jsx)((0, $8z7A0.TestimonialLumen), {}),
            title: intl.formatMessage({
                id: "ConfluenceSoftwarePage.v4.testimonials.testimonialLumen.title",
                defaultMessage: "Director, Agile Transformation Office, Lumen Technologies"
            }),
            image: "https://wac-cdn.atlassian.com/misc-assets/webp-images/confluence/testimonial-lumen.webp",
            quote: intl.formatMessage({
                id: "ConfluenceSoftwarePage.v4.testimonials.testimonialLumen.quote",
                defaultMessage: "Employees across the company use Confluence to document important information like objectives and key results, which helps keep teams aligned across the big-picture goals."
            }),
            label: "Lumen"
        }
    ];
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $dyZbY.default), {
        name: "confluence-pt-cfind-1234-testimonialsSection",
        children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
            className: (0, $esG4f.default)([
                "_1q51ckbl _1av31jry _125xu67f _1com1osq _1bdu18r2 _1c8yor1b"
            ]),
            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $1HoZL.ADG4CustomerTestimonials), {
                testimonials: testimonials,
                imagePosition: "right",
                testimonialCta: /*#__PURE__*/ (0, $loA2J.jsx)($8af0183533d4b69f$var$TestimonialCta, {})
            })
        })
    });
};
$8af0183533d4b69f$var$TestimonialsSection.displayName = "TestimonialsSection";
const $8af0183533d4b69f$var$ctaContainerStyles = null;
const $8af0183533d4b69f$var$TestimonialCta = ()=>{
    const intl = (0, $f6qj2.default)();
    const customersLink = (0, $3FBn4.useLocalizedHref)("/customers");
    const linkText = intl.formatMessage({
        id: "ConfluenceSoftwarePage.v4.testimonials.ctaButton.text",
        defaultMessage: "Explore customer stories"
    });
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: (0, $esG4f.default)([
            "_4cvr1h6o _mqm25xei _16jlkb7n _4t3i1osq _y4tifatv _1e0c1txw _1bahesu3 _152tt94y _kqswh2mm _xlmcidpf _wnjd1h6o _wm3b189y _4bscidpf _1uwridpf _7sgdidpf _1b3nidpf"
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $91nJf.Adg4Button), {
            href: customersLink,
            variant: "secondary",
            color: "white",
            dataEventProps: {
                "data-product-key": "confluence",
                "data-event": "clicked",
                "data-event-component": "linkButton",
                "data-event-container": "testimonialsSection",
                "data-label": "testimonials-cta",
                "data-label-english": "Explore customer stories",
                "data-track-event": "confluence-pt.testimonials.cta"
            },
            children: linkText
        })
    });
};
var $8af0183533d4b69f$export$2e2bcd8739ae039 = $8af0183533d4b69f$var$TestimonialsSection;

});

parcelRegister("kYHPO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ff2d077a9336a552$export$2e2bcd8739ae039; });
/* why-confluence-section.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7Knp0 = parcelRequire("7Knp0");

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $f6qj2 = parcelRequire("f6qj2");

var $dyZbY = parcelRequire("dyZbY");

var $2C7km = parcelRequire("2C7km");

var $5ohHq = parcelRequire("5ohHq");
parcelRequire("2NBOx");
var $4FVkO = parcelRequire("4FVkO");
const $ff2d077a9336a552$var$whyConfluenceSectionStyles = null;
const $ff2d077a9336a552$var$whyBackgroundStyles = null;
const $ff2d077a9336a552$var$relative = null;
const $ff2d077a9336a552$var$whyConfluenceSectionHeaderStyles = null;
const $ff2d077a9336a552$var$infoCardContainerStyles = null;
const $ff2d077a9336a552$var$infoBoxGroup = null;
const $ff2d077a9336a552$var$WhyConfluenceSection = ()=>{
    const intl = (0, $f6qj2.default)();
    const infoBoxes1 = [
        {
            infoBoxId: "versatileContentCreation",
            title: intl.formatMessage((0, $4FVkO.whyConfluenceSectioni18n).versatileContentCreationInfoBoxTitle),
            paragraph: intl.formatMessage((0, $4FVkO.whyConfluenceSectioni18n).versatileContentCreationInfoBoxParagraph)
        },
        {
            infoBoxId: "organizationThatScales",
            title: intl.formatMessage((0, $4FVkO.whyConfluenceSectioni18n).organizationThatScalesInfoBoxTitle),
            paragraph: intl.formatMessage((0, $4FVkO.whyConfluenceSectioni18n).organizationThatScalesInfoBoxParagraph)
        }
    ];
    const infoBoxes2 = [
        {
            infoBoxId: "powerfulIntegrations",
            title: intl.formatMessage((0, $4FVkO.whyConfluenceSectioni18n).powerfulIntegrationsInfoBoxTitle),
            paragraph: intl.formatMessage((0, $4FVkO.whyConfluenceSectioni18n).powerfulIntegrationsInfoBoxParagraph)
        },
        {
            infoBoxId: "dataProtection",
            title: intl.formatMessage((0, $4FVkO.whyConfluenceSectioni18n).dataProtectionInfoBoxTitle),
            paragraph: intl.formatMessage((0, $4FVkO.whyConfluenceSectioni18n).dataProtectionInfoBoxParagraph)
        }
    ];
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $dyZbY.default), {
        name: "confluence-pt-cfind-1234-whyConfluenceSection",
        children: /*#__PURE__*/ (0, $loA2J.jsxs)("section", {
            className: (0, $esG4f.default)([
                "_kqswh2mm _1e0c1txw _2lx21bp4 _4cvr1h6o _1q51ys9h _85i5vbgk _bozg1tcg _y4ti1tcg"
            ]),
            children: [
                /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                    className: (0, $esG4f.default)([
                        "_kqswstnw _mkrz1sm8 _bfhk1rga _p12f1git _1bsb1osq _1tkekbql _4t3i1osq _152tidpf _h15z5580 _1vth1k1d _tnru1osq"
                    ]),
                    style: {
                        "--_1nu1zxz": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light100"))
                    }
                }),
                /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                    className: (0, $esG4f.default)([
                        "_kqswh2mm _1e0c1txw _2lx21bp4 _4cvr1h6o"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $loA2J.jsx)("h2", {
                            className: (0, $esG4f.default)([
                                "_1pfhidpf _6rth8vuz _gu181h6o"
                            ]),
                            children: intl.formatMessage((0, $4FVkO.whyConfluenceSectioni18n).whyConfluenceSectionHeader)
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                            className: (0, $esG4f.default)([
                                "_1e0c1txw _2lx2vrvc _1n261g80 _zulpzwfg _19pkidpf _2hwx1wug _otyridpf _18u01wug _1bsb1osq"
                            ]),
                            children: [
                                /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                    className: (0, $esG4f.default)([
                                        "_1e0c1txw _16jlkb7n _1o9zkb7n _i0dl1wug _zulpzwfg _1bah1h6o _1n261g80"
                                    ]),
                                    children: infoBoxes1.map((infoCardProps)=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $2C7km.InfoBox), (0, $7Knp0._)({}, infoCardProps), infoCardProps.infoBoxId))
                                }),
                                /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                    className: (0, $esG4f.default)([
                                        "_1e0c1txw _16jlkb7n _1o9zkb7n _i0dl1wug _zulpzwfg _1bah1h6o _1n261g80"
                                    ]),
                                    children: infoBoxes2.map((infoCardProps)=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $2C7km.InfoBox), (0, $7Knp0._)({}, infoCardProps), infoCardProps.infoBoxId))
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
$ff2d077a9336a552$var$WhyConfluenceSection.displayName = "WhyConfluenceSection";
var $ff2d077a9336a552$export$2e2bcd8739ae039 = $ff2d077a9336a552$var$WhyConfluenceSection;

});
parcelRegister("2C7km", function(module, exports) {

$parcel$export(module.exports, "InfoBox", function () { return $d5da2332348d2cd7$export$aff4fc93593c3bcf; });
/* info-box.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
const $d5da2332348d2cd7$var$infoBoxContainerStyles = null;
const $d5da2332348d2cd7$var$imageStyles = null;
const $d5da2332348d2cd7$var$titleStyles = null;
const $d5da2332348d2cd7$var$paragraphStyles = null;
const $d5da2332348d2cd7$export$aff4fc93593c3bcf = ({ imageUrl: imageUrl, imageHeight: imageHeight, imageWidth: imageWidth, containerWidth: containerWidth, title: title, paragraph: paragraph })=>{
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        style: {
            width: containerWidth !== null && containerWidth !== void 0 ? containerWidth : 290
        },
        className: (0, $esG4f.default)([
            "_1e0c1txw _1tke1kr5 _2lx21bp4 _1bah1h6o _4cvr1y6m _1o9zidpf"
        ]),
        children: [
            imageUrl && /*#__PURE__*/ (0, $loA2J.jsx)("img", {
                src: imageUrl,
                alt: title,
                height: imageHeight ? imageHeight : "100%",
                width: imageWidth ? imageWidth : "100%",
                className: (0, $esG4f.default)([
                    "_p12f1osq _6rth19bv"
                ])
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("h3", {
                className: (0, $esG4f.default)([
                    "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _1yt4u2gc _1e0c1txw _2lx2vrvc _4cvrv2br",
                    "h4"
                ]),
                children: title
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                className: (0, $esG4f.default)([
                    "_1tke1obz _19pkidpf _2hwxidpf _otyridpf _18u0idpf _6rth1wug _1yt4u2gc"
                ]),
                children: paragraph
            })
        ]
    });
};

});







//# sourceMappingURL=confluence-software-page.b4722d74.js.map
